import {LANGUAGE} from "@/common/utils/constants.js";

export const COMMON = {
	[LANGUAGE.en.short]: {
		areYouSure: "Are you sure?",
		confirmAction: "Confirm action",
		areYouSureYouWantToUnpublish: "Are you sure you want to unpublish",
		areYouSureYouWantToArchive: "Are you sure you want to archive",
		areYouSureYouWantToReturnProjectToDraft: "Are you sure you want to return the project to the RO?",
		areYouSureYouWantToRejectProject: "Are you sure you want to reject the project?",
		areYouSureYouWantToDeleteProject: "Are you sure you want to delete the project?",
		areYouSureYouWantToUnarchiveProject: "Are you sure you want to unarchive the project?",
		areYouSureYouWantToArchiveProject: "Are you sure you want to archive the project?",
		theProject: "the project",
		yes: 'Yes',
		no: "No",
		ok: 'OK',
		websiteUnderMaintenance: "Website under maintenance",
		weAreImprovingWebsite: "We are improving our website. We will be back soon",
		startYear: "Start year",
		startMonth: "Start month",
		endYear: "End year",
		endMonth: "End month",
		year: "Year",
		month: "Month",
		day: "Day",
		denying: "Denying",
		deny: "Deny",
		cancel: "Cancel",
		approving: "Approving",
		approve: "Approve",
		save: "Save",
		preview: "Preview",
		edit: "Edit",
		loading: "Loading",
		yourSessionHasExpired: "Your session has expired",
		pleaseLoginAgain: "Please login again after:",
		youWillBeLoggedOutIn: "You are going to be logged out.",
		backToRO: "Back to RO",
		rejectButton: "Reject",
		reasons: "Please write below the reasons for returning.",
		reasonsForRejecting: "Please write below the reasons for rejecting.",
		writeHere: "Write the text here",
		commonPopupPlaceholder: "Write your text here",
		commonPopupError: "The text field is required.",
		name: "Name",
		intro: "Intro",
		offerPresentation: "Offer Presentation",
		presentationAndVideoLink: "Presentation and video link",
		globalOwners: "Owners",
		akkodisExpertise: "Akkodis expertise",
		marketInsights: "Market insights",
		clientNeedsAndBenefits: "Client needs and benefits",
		tipsAndTricks: "Tips and tricks",
		referencesAndSuccessStories: "References and success stories",
		actions: 'Actions',
		validate: 'Validate',
		backToTop: 'Back to top',
		submit: 'Submit',
		presentationType: 'Sector or Offer Presentation',
		presentationTypeSector: 'Sector',
		presentationTypeOffer: 'Offer',
		title: 'Title',
		presentationTitleHere: 'Presentation title here',
		thumbnail: 'Thumbnail',
		thumbnailHint: "Resolution: Egal or Bigger than 300x200px. Ratio: rectangular 3:2",
		panoramicPhoto: 'Panoramic photo',
		panoramicPhotoHint: "Resolution: 1920x535px or 1200x338px.",
		description: 'Description',
		descriptionPlaceholder: 'Please provide background information on the Offer or Sector presentation. The reasons and the context of this one, the added value for the client.',
		descriptionHint: "Please provide background information on the Offer or Sector presentation. The reasons and the context of this one, the added value for the client. About 600-800 characters with spaces.",
		deliveryLocation: 'Delivery location',
		deliveryLocationPlaceholder: "Select one or more countries",
		singleDeliveryLocationPlaceholder: "Select one country",
		deliveryLocationHint: "List all countries where activities associated to the offer could be delivered",
		length: "Length",
		ftes: "FTEs",
		ftesHint: "Enter the number of Akkodis' employees who are involved in this activity",
		presentationPPT: "Presentation version PPT",
		presentationPPTHint: "Upload the PPT version of the presentation (English language only)",
		presentationPDF: "Presentation version PDF",
		presentationPDFHint: "Upload the PDF version of the presentation (English language only)",
		email: "Email",
		globalOwnersNameHint: 'Owner will only be visible internally in GOP. They will not be visible in external documents.',
		globalOwnersEmailHint: 'Owner will only be visible internally in GOP. They will not be visible in external documents.',
		globalOwnersNamePlaceholder: "Example: John Silverman",
		globalOwnersEmailPlaceholder: "Example: JohnSilverman@akkodis.com",
		globalOwnersSubTitle: "Owner",
		addItem: "Add item",
		removeItem: "Remove item",
		addGlobalOwner: "Add Owner",
		removeGlobalOwner: "Remove Owner",
		videoLink: "Video link",
		videoLinkHint: "You can share external links to video related to the Sector or Office Presentation",
		videoLinkPlaceholder: "URL of the video...",
		projectIndustry: "Project Industry",
		projectIndustryHint: "You can choose only one industry for this offer or sector presentation. Unavailable for Corporate Presentations",
		serviceLines: "Type of Business",
		serviceLinesHint: "You can choose more than one type of business for this offer or sector presentation",
		techPractices: "Tech Practices",
		techPracticesHint: "You can choose more than one tech practice for this offer or sector presentation",
		mainClientPersona: "Main Client Persona",
		mainClientPersonaHint: "You can choose more than one main client persona for this offer or sector presentation",
		mainClientPersonaPlaceholder: "Select one or more domain",
		lifecycle: "Life Cycle",
		lifecycleHint: "You can choose more than one life cycle for this offer or sector presentation",
		lifecyclePlaceholder: "Select one or more Life Cycle part",
		toolsAndSystems: "Tools and Systems",
		toolsAndSystemsHint: "Hardware and Software used by the team and technologies used. When you add a new tool that is not in the provided options the background colour of it will be yellow. After it is approved, background will be changed back to blue",
		toolsAndSystemsPlaceholder: "Select one or more Tools & Systems",
		certifications: "Certifications",
		certificationsHint: "Standarts, Methodologies and Frameworks used. When you add a new certification that is not in the provided options the background colour of it will be yellow. After it is approved, background will be changed back to blue",
		certificationsPlaceholder: "Select one or more Certifications",
		largestMarket: "Largest Market",
		largestMarketHint: "Select countries in the largest market",
		largestMarketPlaceholder: "Select one or more countries",
		fastestGrowingMarket: "Fastest Growing Market",
		fastestGrowingMarketHint: "Select countries in the fastest growing market",
		fastestGrowingMarketPlaceholder: "Select one or more countries",
		biggestMarketConclusion: "Biggest Market Conclusion",
		biggestMarketConclusionHint: "You can provide a conclusion information about the biggest markets section. About 150-250 characters with spaces.",
		biggestMarketConclusionPlaceholder: "Example: Market size value in 2022 USD 285 million",
		keyMarketDrivers: "Key Market Drivers",
		keyMarketDriversHint: "Please provide information about key market drivers. About 400-600 characters with spaces.",
		keyMarketDriversPlaceholder: "Please provide information about key market drivers.",
		marketOpportunities: "Market Opportunities",
		marketOpportunitiesHint: "Please provide information about market opportunities. About 400-600 characters with spaces.",
		marketOpportunitiesPlaceholder: "Please provide information about market opportunities.",
		clientNeeds: "Client Needs",
		clientNeedsHint: "Please provide information about client needs. About 400-600 characters with spaces.",
		clientNeedsPlaceholder: "Message.",
		clientBenefits: "Client Benefits",
		clientBenefitsHint: "Please provide information about client benefits. About 400-600 characters with spaces.",
		clientBenefitsPlaceholder: "Message.",
		tips: "Tips",
		tipsHint: "Please provide information about client needs. About 600-800 characters with spaces.",
		tipsPlaceholder: "Message.",
		keyHighlights: "Key Highlights",
		keyHighlightsHint: "Please provide information about key highlights. About 400-600 characters with spaces.",
		keyHighlightsPlaceholder: "Please provide information about key market drivers.",
		additionalNotes: "Additional Notes",
		additionalNotesHint: "If relevant, add additional notes for stakeholder who will take in charge the presentation of this offer or Sector Presentation. About 400-600 characters.",
		additionalNotesPlaceholder: "Please provide information about key market drivers.",
		competitors: "Competitors",
		competitorsHint: "Select Akkodis competitors in the market. When you add a new competitor that is not in the provided options the background color of it will be yellow. After it is approved, background will be changed back to blue",
		competitorsPlaceholder: "Select one or more competitors.",
		addReference: "Add Reference",
		removeReference: "Remove",
		references: "References",
		referenceDescription: "Description",
		referenceDescriptionHint: "If relevant, provide information about the reference used.",
		referenceDescriptionPlaceholder: "Example: HFS Horizons: Generative Enterprise Services, 2023.",
		referenceUrl: "URL",
		referenceUrlHint: "If relevant, provide the reference used.",
		referenceUrlPlaceholder: "Example: https://www.hfsresearch.com/Generative-enterprise-2023",
		pleaseWait: "Please wait...",
		language: "Choose language",
		languageHint: "When you submit in other language your Offer or Sector Presentation will be auto-translated into English. ",
		languagePlaceholder: "Please choose the language in which you want to submit your Offer or Sector Presentation",
		copyUrlSuccess: "The URL has been copied successfully.",
		akkodisAndIndustryPresentation: "Akkodis, Industry & Practice Presentations",
		sectorPresentation: "Industry Presentation",
		generalPresentation: "General Presentation",
		mainTechPractice: "Main Tech Practice",
		mainGlobalOwner: 'Main Owner',
		mainGlobalOwnerPlaceholder: 'Select one main owner',
		mainGlobalOwnerHint: 'You can choose only one main owner',
		mainTechPracticeHint: "You can choose only one main tech practice",
		mainTechPracticePlaceholder: "Select one tech practice",
		mainProjectIndustry: "Main Project Industry",
		mainProjectIndustryHint: "You can choose only one main project industry. Unavailable for Corporate Presentations",
		mainProjectIndustryPlaceholder: "Select one project industry",
		mobilePanoramicPhoto: 'Mobile Panoramic photo',
		mobilePanoramicPhotoHint: "Resolution: 480x400px or 460x400px",
		doYouWantToProceedWithSubmit: "Do you want to proceed? You still have empty fields.",
		emptyFields: "Empty fields",
		referenceStory: "Reference Story",
		offerType: "Offer Type",
		offerTypeLabel: "Choose type",
		offerTypeHint: "Please select the type of offer you are submitting",
		offerTypePlaceholder: "Please choose the type of offer you want",
		globalOffer: "Parent Offer",
		globalOfferHint: "Please select the parent offer for this offer",
		globalOfferPlaceholder: "Please choose the parent of the localized offer",
		deliveryLocationDisabledHint: "Country unavalable, due to already existing localized offer about this country",
		local: "Local",
		global: "Global",
		localized: "Localized",
		relatedOffersByContent: "Related offers by content",
		relatedSectorsByContent: "Related sector presentations by content",
		relatedPresentationsByContent: "Related presentations by content",
		english: "English",
		french: "French",
		german: "German",
		italian: "Italian",
		japanese: "Japanese",
		spanish: "Spanish",
		noTitle: "No title",
		noRelatedOffers: "No related offers",
		noRelatedSectors: "No related sector presentations",
		originalTranslation: "ORIGINAL TRANSLATION",
		for: "for",
		addOffer: "Add Offer",
		removeOffer: "Remove",
		offerReferences: "Related Offers",
		offerLabel: "Offer",
		offerPlaceholder: "Select a related offer",
		offerLabelEn: "Offers in English",
		offerHintEn: "Select one or more related offers in English",
		offerPlaceholderEn: "Select one or more related offers in English",
		offerLabelFr: "Offers in French",
		offerHintFr: "Select one or more related offers in French",
		offerPlaceholderFr: "Select one or more related offers in French",
		offerLabelDe: "Offers in German",
		offerHintDe: "Select one or more related offers in German",
		offerPlaceholderDe: "Select one or more related offers in German",
		offerLabelIt: "Offers in Italian",
		offerHintIt: "Select one or more related offers in Italian",
		offerPlaceholderIt: "Select one or more related offers in Italian",
		offerLabelJa: "Offers in Japanese",
		offerHintJa: "Select one or more related offers in Japanese",
		offerPlaceholderJa: "Select one or more related offers in Japanese",
		offerLabelEs: "Offers in Spanish",
		offerHintEs: "Select one or more related offers in Spanish",
		offerPlaceholderEs: "Select one or more related offers in Spanish",
		sectorType: "Presentation Type",
		sectorTypeLabel: "Choose type",
		sectorTypeHint: "Please select the type of Presentation you are submitting",
		sectorTypePlaceholder: "Please choose the type of Presentation you want",
		globalSectors: "Global Presentation",
		globalSectorHint: "Please select the parent for this Presentation",
		globalSectorPlaceholder: "Please choose the parent of the localized Presentation",
		sectorReferences: "Related Presentations",
		sectorLabelEn: "Presentations in English",
		sectorHintEn: "Select one or more related Presentations in English",
		sectorPlaceholderEn: "Select one or more related Presentations in English",
		sectorLabelFr: "Presentations in French",
		sectorHintFr: "Select one or more related Presentations in French",
		sectorPlaceholderFr: "Select one or more related Presentations in French",
		sectorLabelDe: "Presentations in German",
		sectorHintDe: "Select one or more related Presentations in German",
		sectorPlaceholderDe: "Select one or more related Presentations in German",
		sectorLabelIt: "Presentations in Italian",
		sectorHintIt: "Select one or more related Presentations in Italian",
		sectorPlaceholderIt: "Select one or more related Presentations in Italian",
		sectorLabelJa: "Presentations in Japanese",
		sectorHintJa: "Select one or more related Presentations in Japanese",
		sectorPlaceholderJa: "Select one or more related Presentations in Japanese",
		sectorLabelEs: "Presentations in Spanish",
		sectorHintEs: "Select one or more related Presentations in Spanish",
		sectorPlaceholderEs: "Select one or more related Presentations in Spanish",
		resources: "Resources",
		resourcesHint: "You can choose more than one resource for this offer or sector presentation",
		resourcesPlaceholder: "Select one or more resources",
		link: "Link",
		links: "Links",
		addLink: "Add Link",
		removeLink: "Remove",
		linkNameHint: "Name of the link used.",
		linkUrlHint: "If relevant, provide the link used.",
		linkName: "Name",
		linkUrl: "URL",
		hintNamePlaceholder: "Example: Relevant news about the market",
		hintUrlPlaceholder: "Example: https://www.relevantnews.com",
		cannotAddMore: "Cannot add more",
		demandGenerationResources: "Demand Generation Resources",
		doYouWantToPreloadGlobalOfferData: "Do you want to pre-fill the form with data from the global offer?",
		doYouWantToPreloadGlobalSectorData: "Do you want to pre-fill the form with data from the global sector presentation?",
		isCorporatePresentation: "Is Corporate Presentation",
		recognitions: 'Akkodis Recognitions',
		recognitionsHint: "You can add recognitions related to this offer or sector presentation, such as awards, analyst recognitions, etc.",
		recognitionsPlaceholder: "Select one or more recognitions",
		uploadLogo: 'Upload Logo',
		uploadResource: 'Upload Resource',
		recognitionDescription: 'Example: ER&D Services and Digital Engineering',
		recognitionLinkHint: 'Recognition link can be added if there is no resource uploaded. If you want to add a link, please remove the resource.',
		recognitionsWarning: 'Note that an incomplete recognition will not be saved.',
		recognitionsWarningHint: "Incomplete recognition is one without Description, Logo or doesn't have Link or File.",
		addEditor: "Add Editor",
		removeEditor: "Remove",
		editors: "Editors",
		editorsHint: "Give rights to a person that can edit, save and submit.",
		editorPlaceholder: "Select one or more editors",
		editorsSubTitle: "Editor",
		footer: {
			contactUs: 'Contact us',
			reportProblem: "Report a problem",
			resources: "Resources",
			contactCMT: 'Contact CMT'
		},
		confirmationRequired: 'Confirmation required',
		projects: "Projects",
		publishedProjects: 'Published Projects',
		revenues: "Revenues",
		drafts: "Drafts",
		archived: "Archived",
		shared: "Shared",
		forReview: "For Review",
		surveyQuestions: "Survey Questions",
		needHelp: 'Need help? Click here.',
		surveyName: "Survey name",
		question: "Question",
		deleteQuestion: "Delete Question",
		addQuestion: "Add Question",
		type: 'Type',
		enterQuestionText: "Enter question text",
		answerText: "Answer text",
		deleteAnswer: "Delete answer",
		answers: "Answers",
		singleChoice: "Single choice",
		multipleChoice: "Multiple choice",
		textResponse: "Text Response",
		addAnswer: "Add Answer",
		createSurvey: "Create Survey",
		areYouSureYouWantToDeleteSurvey: "Are you sure you want to delete the survey?",
		saveSurvey: "Save Survey",
		surveySaveSuccess: "Survey saved successfully.",
		surveyGetFailed: "A Problem occured when trying to get survey. Please try again, if the problem persists, contact CMT team.",
		surveyNotValid: "Survey is not valid. Please check the questions and answers.",
		errorSavingSurvey: "Error saving survey. Please try again, if the problem persists, contact CMT team.",
		delete: "Delete",
		active: "Active",
		setActive: "Set Active",
		activate: 'Activate',
		deactivate: 'Deactivate',
		createVideo: "Create Video",
		wrongTypePleaseUploadVideo: "Wrong file type! Please upload a video file.",
		hide: 'Hide',
		show: 'Show',
		deleteVideoMessage: "Are you sure you want to delete this video?",
		videoDeletedSuccessfully: "Video deleted successfully.",
		successfullySavedVideo: "Successfully saved video.",
		wrongId: "Item does not exist. Please check the URL.",
		fillAllFields: "Please fill all fields.",
		currentVideo: "Current Video",
		videoTitle: "Video Title",
		videoDescription: "Video Description",
		confirmVideoTranslations: "Saving will override existing translations and will apply automatic translations from English. Are you sure you want to continue?",
		successfullyCreatedVideo: "Successfully created video.",
		errorWhileSaving: "Error while saving. Please try again, if the problem persists, contact CMT team.",
		deleteResourceFileMessage: "Are you sure you want to delete this resource file?",
		resourceFileDeletedSuccessfully: "Resource file deleted successfully.",
		successfullySavedResourceFile: "Successfully saved resource file.",
		currentResourceFile: "Current Resource File",
		resourceFileTitle: "Resource File Title",
		resourceFileDescription: "Resource File Description",
		confirmResourceFileTranslations: "Saving will override existing translations and will apply automatic translations from English. Are you sure you want to continue?",
		successfullyCreatedResourceFile: "Successfully created resource file.",
		createResourceFile: "Create Resource File",
		wrongTypePleaseUploadResourceFile: "Wrong file type! Please upload a resource file.",
		downloadCurrentFile: "Download Current File",
		createPromotion: "Create Promotion",
		deletePromotionMessage: "Are you sure you want to delete this promotion?",
		promotionDeletedSuccessfully: "Promotion deleted successfully.",
		pleaseSelectProject: "Please select a project.",
		promotionCreatedSuccessfully: "Promotion created successfully.",
		increase: "Increase",
		decrease: "Decrease",
		promotedUntil: "Promoted Until",
		selectAProjectForPromotion: "Select a project for promotion",
		promote: "Promote",
		categoryLabel: "Category",
		categoryPlaceholder: "Select a category",
		categoryHint: "Select a category for this presentation",
		doYouWantToSendEmailForNextPublishing: "Do you want to send an email to the reference owner when the project is published next time?",
		emailDisabledOnPublish: "Email will NOT be sent to the owner when the project is published next time.",
		sendEmail: "Send Email?",
		annualRevenue: "Annual Revenue",
		annualRevenueHint: "Enter the annual revenue generated from this project",
		annualRevenuePlaceholder: "Enter annual revenue",
		maturity: "Maturity",
		maturityHint: "Select the maturity level of this project",
		maturityPlaceholder: "Select maturity level",
		confirmAndClose: "Confirm and Close",
		startTour: "Start Tour",
		welcome: "Welcome!",
		welcomeText: "The new version of GOP is now available. Please select your country to personalize your experience. You can start a quick tour to explore what´s new or simply confirm and close.",
		country: "Country",
		countryPlaceholder: "Select",
		countryError: "Please select a country to continue.",
		recognition: "Recognition",
		titlePlaceholder: "Enter Title Here",
		file: 'File',
		fileHint: 'Upload a file',
		logo: "Logo",
		logoHint: "Upload a logo",
		url: "URL",
		urlPlaceholder: "Enter a URL",
		region: "Region",
		regionPlaceholder: "Select region",
		infoDatePlaceHolder: 'Select the specific year related to this recognition',
		badge: "Badge",
		analysts: "Analysts",
		analystsPlaceholder: "Select analysts",
		additionalLinks: "Additional Links",
		insights: "Insights",
		insightsPlaceholder: "Please Provide insights related to this recognition, such as why it was given, what it means for Akkodis, etc.",
		relatedPartnershipPresentations: "Related Partnership Presentations",
		relatedPartnershipPresentationsPlaceholder: "Select one or more related partnership presentations",
		relatedSectors: "Related Sector Presentations",
		relatedSectorsPlaceholder: "Select one or more related sector presentations",
		relatedSectorsHint: "Select one or more related sector presentations",
		relatedOffers: "Related Offers",
		relatedOffersPlaceholder: "Select one or more related offers",
		relatedOffersHint: "Select one or more related offers",
		images: "Images",
		logoAndBadge: "Logo and Badge",
		relatedAndImages: "Related & Images",
		recognitionFileLabel: "File",
		recognitionFileHint: "Upload a file. You can either fill in URL or upload a file. Uploading a file will override the URL with uploaded file's url",
		addCountrySectorItems: "Add Item",
		removeCountrySectorItems: "Remove Item",
		countrySectorItems: "Country Sector Items",
		countrySectorItemResultHint: "Country Sector Item Number displayed next to the country image",
		countrySectorItemTextHint: "Text displayed next to the country image",
		countrySectorItemResult: "Number",
		countrySectorItemText: "Text",
		countrySectorItemResultPlaceholder: 'Example: "20"',
		countrySectorItemTextPlaceholder: 'Example: "Locations throughout Germany and in close proximity to our customers"',
		countryImage: "Country Map Image",
		countryImageHint: "Upload a country Map image that will be displayed in the country presentation page next to the country items",
		recognitionGalleryUploadGroupHint: "Upload gallery for Recognition. You can upload images related to the recognition, such as photos from the award ceremony, images of the award itself, etc.",
		videoLinks: "Video Links",
		videoHintNamePlaceholder: 'Example: "Relevant news about the market"',
		videoHintUrlPlaceholder: 'Example: "https://www.example.com"',
		countries: "Country",
		infoDate: "Year",
		marketData: 'Market Data'
	},
	[LANGUAGE.de.short]: {
		areYouSure: "Bist du sicher?",
		confirmAction: "Aktion bestätigen",
		areYouSureYouWantToUnpublish: "Sind Sie sicher, dass Sie die Veröffentlichung aufheben möchten?",
		areYouSureYouWantToArchive: "Sind Sie sicher, dass Sie archivieren möchten?",
		areYouSureYouWantToReturnProjectToDraft: "Sind Sie sicher, dass Sie das Projekt an die RO zurückgeben möchten?",
		areYouSureYouWantToRejectProject: "Möchten Sie das Projekt wirklich ablehnen?",
		areYouSureYouWantToDeleteProject: "Sind Sie sicher, dass Sie das Projekt löschen möchten?",
		areYouSureYouWantToUnarchiveProject: "Sind Sie sicher, dass Sie das Projekt wiederherstellen möchten?",
		areYouSureYouWantToArchiveProject: "Sind Sie sicher, dass Sie das Projekt archivieren möchten?",
		theProject: "das Projekt",
		yes: 'Ja',
		no: "Nein",
		ok: 'OK',
		websiteUnderMaintenance: "Website wird gewartet",
		weAreImprovingWebsite: "Wir verbessern unsere Website. Wir werden bald zurück sein",
		startYear: "Startjahr",
		startMonth: "Startmonat",
		endYear: "Endjahr",
		endMonth: "Endmonat",
		year: "Jahr",
		month: "Monat",
		day: "Tag",
		denying: "Leugnen",
		deny: "Ablehnen",
		cancel: "Stornieren",
		approving: "Zustimmend",
		approve: "Genehmigen",
		save: "Speichern",
		preview: "Vorschau",
		edit: "Bearbeiten",
		loading: "Wird geladen",
		yourSessionHasExpired: "Ihre Sitzung ist abgelaufen",
		pleaseLoginAgain: "Bitte melden Sie sich erneut an nach:",
		youWillBeLoggedOutIn: "Sie werden abgemeldet.",
		backToRO: "Zurück zu RO",
		rejectButton: "Ablehnen",
		reasons: "Bitte geben Sie unten die Gründe für die Rücksendung an.",
		reasonsForRejecting: "Bitte geben Sie unten die Gründe für die Ablehnung an.",
		writeHere: "Schreiben Sie hier den Text",
		commonPopupPlaceholder: "Schreiben Sie hier Ihren Text",
		commonPopupError: "Das Textfeld ist erforderlich.",
		name: "Name",
		intro: "Einführung",
		offerPresentation: "Angebot Präsentation",
		presentationAndVideoLink: "Präsentation und Video-Link",
		globalOwners: "Eigentümer",
		akkodisExpertise: "Akkodis Expertise",
		marketInsights: "Markteinblicke",
		clientNeedsAndBenefits: "Kundenbedürfnisse und Vorteile",
		tipsAndTricks: "Tipps und Tricks",
		referencesAndSuccessStories: "Referenzen und Erfolgsgeschichten",
		actions: 'Aktionen',
		validate: 'Validieren',
		backToTop: 'Zurück nach oben',
		submit: 'Einreichen',
		presentationType: 'Sektor oder Angebotspräsentation',
		presentationTypeSector: 'Sektor',
		presentationTypeOffer: 'Angebot',
		title: 'Titel',
		presentationTitleHere: 'Präsentationstitel hier',
		thumbnail: 'Vorschaubild',
		thumbnailHint: "Auflösung: Gleich oder größer als 300x200px. Seitenverhältnis: rechteckig 3:2",
		panoramicPhoto: 'Panoramafoto',
		panoramicPhotoHint: "Auflösung: 1920x535px oder 1200x338px.",
		description: 'Beschreibung',
		descriptionPlaceholder: 'Bitte geben Sie Hintergrundinformationen zur Angebots- oder Sektordarstellung an. Die Gründe und der Kontext dieser, der Mehrwert für den Kunden.',
		descriptionHint: "Bitte geben Sie Hintergrundinformationen zur Angebots- oder Sektordarstellung an. Die Gründe und der Kontext dieser, der Mehrwert für den Kunden. Etwa 600-800 Zeichen mit Leerzeichen.",
		deliveryLocation: 'Lieferort',
		deliveryLocationPlaceholder: "Wählen Sie ein oder mehrere Länder aus",
		singleDeliveryLocationPlaceholder: "Wählen Sie ein Land",
		deliveryLocationHint: "Liste aller Länder, in denen Aktivitäten im Zusammenhang mit dem Angebot durchgeführt werden können",
		length: "Länge",
		ftes: "VZÄ",
		ftesHint: "Geben Sie die Anzahl der Mitarbeiter von Akkodis ein, die an dieser Aktivität beteiligt sind",
		presentationPPT: "Präsentationsversion PPT",
		presentationPPTHint: "Laden Sie die PPT-Version der Präsentation hoch (nur englische Sprache)",
		presentationPDF: "Präsentationsversion PDF",
		presentationPDFHint: "Laden Sie die PDF-Version der Präsentation hoch (nur englische Sprache)",
		email: "Email",
		globalOwnersNameHint: 'Owner wird nur intern in GOP sichtbar sein. Sie werden in externen Dokumenten nicht sichtbar sein.',
		globalOwnersEmailHint: 'Owner wird nur intern in GOP sichtbar sein. Sie werden in externen Dokumenten nicht sichtbar sein.',
		globalOwnersNamePlaceholder: "Beispiel: John Silverman",
		globalOwnersEmailPlaceholder: "Beispiel: JohnSilverman@akkodis.com",
		globalOwnersSubTitle: "Owner",
		addItem: "Element hinzufügen",
		removeItem: "Element entfernen",
		addGlobalOwner: "Owner hinzufügen",
		removeGlobalOwner: "Owner entfernen",
		videoLink: "Video-Link",
		videoLinkHint: "Sie können externe Links zu Videos im Zusammenhang mit der Sektor- oder Angebotspräsentation teilen",
		videoLinkPlaceholder: "URL des Videos...",
		projectIndustry: "Projektindustrie",
		projectIndustryHint: "Sie können nur eine Branche für dieses Angebot oder diese Sektordarstellung auswählen. Nicht verfügbar für Unternehmenspräsentationen",
		serviceLines: "Geschäftsart",
		serviceLinesHint: "Sie können für dieses Angebot oder diese Branchenpräsentation mehrere Geschäftsarten auswählen.",
		techPractices: "Tech-Praktiken",
		techPracticesHint: "Sie können mehr als eine Tech-Praxis für diese Angebots- oder Sektordarstellung auswählen",
		mainClientPersona: "Hauptkunden-Persona",
		mainClientPersonaHint: "Sie können mehr als eine Hauptkunden-Persona für diese Angebots- oder Sektordarstellung auswählen",
		mainClientPersonaPlaceholder: "Wählen Sie eine oder mehrere Domänen",
		lifecycle: "Lebenszyklus",
		lifecycleHint: "Sie können mehr als einen Lebenszyklus für diese Angebots- oder Sektordarstellung auswählen",
		lifecyclePlaceholder: "Wählen Sie einen oder mehrere Lebenszyklus-Teile",
		toolsAndSystems: "Werkzeuge und Systeme",
		toolsAndSystemsHint: "Hardware und Software, die vom Team und verwendeten Technologien verwendet werden. Wenn Sie ein neues Tool hinzufügen, das nicht in den bereitgestellten Optionen enthalten ist, wird die Hintergrundfarbe gelb. Nach der Genehmigung wird der Hintergrund wieder blau",
		toolsAndSystemsPlaceholder: "Wählen Sie ein oder mehrere Tools & Systeme",
		certifications: "Zertifizierungen",
		certificationsHint: "Verwendete Standards, Methodologien und Frameworks. Wenn Sie eine neue Zertifizierung hinzufügen, die nicht in den bereitgestellten Optionen enthalten ist, wird die Hintergrundfarbe gelb. Nach der Genehmigung wird der Hintergrund wieder blau",
		certificationsPlaceholder: "Wählen Sie eine oder mehrere Zertifizierungen",
		largestMarket: "Größter Markt",
		largestMarketHint: "Wählen Sie Länder im größten Markt",
		largestMarketPlaceholder: "Wählen Sie ein oder mehrere Länder",
		fastestGrowingMarket: "Schnellst wachsender Markt",
		fastestGrowingMarketHint: "Wählen Sie Länder im am schnellsten wachsenden Markt",
		fastestGrowingMarketPlaceholder: "Wählen Sie ein oder mehrere Länder",
		biggestMarketConclusion: "Größter Markt Schlussfolgerung",
		biggestMarketConclusionHint: "Sie können eine Schlussfolgerungsinformation über den größten Marktabschnitt bereitstellen. Etwa 150-250 Zeichen mit Leerzeichen.",
		biggestMarketConclusionPlaceholder: "Beispiel: Marktwert in 2022 USD 285 Millionen",
		keyMarketDrivers: "Wichtigste Markttreiber",
		keyMarketDriversHint: "Bitte geben Sie Informationen zu den wichtigsten Markttreibern an. Etwa 400-600 Zeichen mit Leerzeichen.",
		keyMarketDriversPlaceholder: "Bitte geben Sie Informationen zu den wichtigsten Markttreibern an.",
		marketOpportunities: "Marktchancen",
		marketOpportunitiesHint: "Bitte geben Sie Informationen zu den Marktchancen an. Etwa 400-600 Zeichen mit Leerzeichen.",
		marketOpportunitiesPlaceholder: "Bitte geben Sie Informationen zu den Marktchancen an.",
		clientNeeds: "Kundenbedürfnisse",
		clientNeedsHint: "Bitte geben Sie Informationen zu den Kundenbedürfnissen an. Etwa 400-600 Zeichen mit Leerzeichen.",
		clientNeedsPlaceholder: "Nachricht.",
		clientBenefits: "Kundenvorteile",
		clientBenefitsHint: "Bitte geben Sie Informationen zu den Kundenvorteilen an. Etwa 400-600 Zeichen mit Leerzeichen.",
		clientBenefitsPlaceholder: "Nachricht.",
		tips: "Tipps",
		tipsHint: "Bitte geben Sie Informationen zu den Kundenbedürfnissen an. Etwa 600-800 Zeichen mit Leerzeichen.",
		tipsPlaceholder: "Nachricht.",
		keyHighlights: "Hauptmerkmale",
		keyHighlightsHint: "Bitte geben Sie Informationen zu den Hauptmerkmalen an. Etwa 400-600 Zeichen mit Leerzeichen.",
		keyHighlightsPlaceholder: "Bitte geben Sie Informationen zu den wichtigsten Markttreibern an.",
		additionalNotes: "Zusätzliche Hinweise",
		additionalNotesHint: "Fügen Sie bei Bedarf zusätzliche Hinweise für die Stakeholder hinzu, die die Präsentation dieses Angebots oder der Sektordarstellung übernehmen. Etwa 400-600 Zeichen.",
		additionalNotesPlaceholder: "Bitte geben Sie Informationen zu den wichtigsten Markttreibern an.",
		competitors: "Konkurrenten",
		competitorsHint: "Wählen Sie Akkodis-Konkurrenten auf dem Markt aus. Wenn Sie einen neuen Konkurrenten hinzufügen, der nicht in den bereitgestellten Optionen enthalten ist, wird die Hintergrundfarbe gelb. Nach der Genehmigung wird der Hintergrund wieder blau",
		competitorsPlaceholder: "Wählen Sie einen oder mehrere Konkurrenten.",
		addReference: "Referenz hinzufügen",
		removeReference: "Entfernen",
		references: "Referenzen",
		referenceDescription: "Beschreibung",
		referenceDescriptionHint: "Geben Sie bei Bedarf Informationen zur verwendeten Referenz an.",
		referenceDescriptionPlaceholder: "Beispiel: HFS Horizons: Generative Enterprise Services, 2023.",
		referenceUrl: "URL",
		referenceUrlHint: "Geben Sie bei Bedarf die verwendete Referenz an.",
		referenceUrlPlaceholder: "Beispiel: https://www.hfsresearch.com/Generative-enterprise-2023",
		pleaseWait: "Bitte warten...",
		language: "Sprache wählen",
		languageHint: "Wenn Sie in einer anderen Sprache einreichen, wird Ihre Angebots- oder Sektordarstellung automatisch ins Englische übersetzt.",
		languagePlaceholder: "Bitte wählen Sie die Sprache, in der Sie Ihre Angebots- oder Sektordarstellung einreichen möchten",
		copyUrlSuccess: "Die URL wurde erfolgreich kopiert.",
		akkodisAndIndustryPresentation: "Akkodis, Branchen- & Praxispräsentationen",
		sectorPresentation: "Branchenpräsentation",
		generalPresentation: "Allgemeine Präsentation",
		mainTechPractice: "Haupttechnikpraxis",
		mainGlobalOwner: 'Haupteigentümer',
		mainGlobalOwnerPlaceholder: "Einen Haupteigentümer auswählen",
		mainGlobalOwnerHint: "Sie können nur einen Haupteigentümer auswählen",
		mainTechPracticeHint: "Sie können nur eine Haupttechnikpraxis auswählen",
		mainTechPracticePlaceholder: "Wählen Sie eine Technikpraxis",
		mainProjectIndustry: "Hauptprojektindustrie",
		mainProjectIndustryHint: "Sie können nur eine Hauptprojektindustrie auswählen. Nicht verfügbar für Unternehmenspräsentationen",
		mainProjectIndustryPlaceholder: "Wählen Sie eine Projektindustrie",
		mobilePanoramicPhoto: 'Mobiles Panoramafoto',
		mobilePanoramicPhotoHint: "Auflösung: 480x400px oder 460x400px",
		doYouWantToProceedWithSubmit: "Möchten Sie fortfahren? Sie haben immer noch leere Felder.",
		emptyFields: "Leere Felder",
		referenceStory: "Referenzgeschichte",
		offerType: "Angebotstyp",
		offerTypeLabel: "Typ auswählen",
		offerTypeHint: "Bitte wählen Sie den Typ des Angebots aus, das Sie einreichen möchten",
		offerTypePlaceholder: "Bitte wählen Sie den gewünschten Angebotstyp aus",
		globalOffer: "Übergeordnetes Angebot",
		globalOfferHint: "Bitte wählen Sie das übergeordnete Angebot für dieses Angebot aus",
		globalOfferPlaceholder: "Bitte wählen Sie das übergeordnete Angebot des lokalisierten Angebots aus",
		deliveryLocationDisabledHint: "Land nicht verfügbar, da bereits ein lokalisiertes Angebot zu diesem Land vorhanden ist",
		local: "Lokal",
		global: "Global",
		localized: "Lokalisiert",
		relatedOffersByContent: "Verwandte Angebote nach Inhalt",
		relatedSectorsByContent: "Verwandte Branchenpräsentationen nach Inhalt",
		relatedPresentationsByContent: "Verwandte Präsentationen nach Inhalt",
		english: "Englisch",
		french: "Französisch",
		german: "Deutsch",
		italian: "Italienisch",
		japanese: "Japanisch",
		spanish: "Spanisch",
		noTitle: "Kein Titel",
		noRelatedOffers: "Keine verwandten Angebote",
		noRelatedSectors: "Keine verwandten Branchenpräsentationen",
		originalTranslation: "ORIGINALÜBERSETZUNG",
		for: "für",
		addOffer: "Angebot hinzufügen",
		removeOffer: "Entfernen",
		offerReferences: "Verwandte Angebote",
		offerLabel: "Angebot",
		offerPlaceholder: "Wählen Sie ein verwandtes Angebot",
		offerLabelEn: "Angebote auf Englisch",
		offerHintEn: "Wählen Sie ein oder mehrere verwandte Angebote auf Englisch",
		offerPlaceholderEn: "Wählen Sie ein oder mehrere verwandte Angebote auf Englisch",
		offerLabelFr: "Angebote auf Französisch",
		offerHintFr: "Wählen Sie ein oder mehrere verwandte Angebote auf Französisch",
		offerPlaceholderFr: "Wählen Sie ein oder mehrere verwandte Angebote auf Französisch",
		offerLabelDe: "Angebote auf Deutsch",
		offerHintDe: "Wählen Sie ein oder mehrere verwandte Angebote auf Deutsch",
		offerPlaceholderDe: "Wählen Sie ein oder mehrere verwandte Angebote auf Deutsch",
		offerLabelIt: "Angebote auf Italienisch",
		offerHintIt: "Wählen Sie ein oder mehrere verwandte Angebote auf Italienisch",
		offerPlaceholderIt: "Wählen Sie ein oder mehrere verwandte Angebote auf Italienisch",
		offerLabelJa: "Angebote auf Japanisch",
		offerHintJa: "Wählen Sie ein oder mehrere verwandte Angebote auf Japanisch",
		offerPlaceholderJa: "Wählen Sie ein oder mehrere verwandte Angebote auf Japanisch",
		offerLabelEs: "Angebote auf Spanisch",
		offerHintEs: "Wählen Sie ein oder mehrere verwandte Angebote auf Spanisch",
		offerPlaceholderEs: "Wählen Sie ein oder mehrere verwandte Angebote auf Spanisch",
		sectorType: "Präsentationstyp",
		sectorTypeLabel: "Typ auswählen",
		sectorTypeHint: "Bitte wählen Sie den Typ der Präsentation aus, die Sie einreichen möchten",
		sectorTypePlaceholder: "Bitte wählen Sie die gewünschte Präsentationsart",
		globalSectors: "Übergeordnete Präsentation",
		globalSectorHint: "Bitte wählen Sie das übergeordnete Element für diese Präsentation aus",
		globalSectorPlaceholder: "Bitte wählen Sie das übergeordnete Element der lokalisierten Präsentation aus",
		sectorReferences: "Verwandte Präsentationen",
		sectorLabelEn: "Präsentationen auf Englisch",
		sectorHintEn: "Wählen Sie ein oder mehrere verwandte Präsentationen auf Englisch",
		sectorPlaceholderEn: "Wählen Sie ein oder mehrere verwandte Präsentationen auf Englisch",
		sectorLabelFr: "Präsentationen auf Französisch",
		sectorHintFr: "Wählen Sie ein oder mehrere verwandte Präsentationen auf Französisch",
		sectorPlaceholderFr: "Wählen Sie ein oder mehrere verwandte Präsentationen auf Französisch",
		sectorLabelDe: "Präsentationen auf Deutsch",
		sectorHintDe: "Wählen Sie ein oder mehrere verwandte Präsentationen auf Deutsch",
		sectorPlaceholderDe: "Wählen Sie ein oder mehrere verwandte Präsentationen auf Deutsch",
		sectorLabelIt: "Präsentationen auf Italienisch",
		sectorHintIt: "Wählen Sie ein oder mehrere verwandte Präsentationen auf Italienisch",
		sectorPlaceholderIt: "Wählen Sie ein oder mehrere verwandte Präsentationen auf Italienisch",
		sectorLabelJa: "Präsentationen auf Japanisch",
		sectorHintJa: "Wählen Sie ein oder mehrere verwandte Präsentationen auf Japanisch",
		sectorPlaceholderJa: "Wählen Sie ein oder mehrere verwandte Präsentationen auf Japanisch",
		sectorLabelEs: "Präsentationen auf Spanisch",
		sectorHintEs: "Wählen Sie ein oder mehrere verwandte Präsentationen auf Spanisch",
		sectorPlaceholderEs: "Wählen Sie ein oder mehrere verwandte Präsentationen auf Spanisch",
		resources: "Ressourcen",
		resourcesHint: "Sie können mehr als eine Ressource für diese Angebots- oder Sektordarstellung auswählen",
		resourcesPlaceholder: "Wählen Sie eine oder mehrere Ressourcen",
		link: "Link",
		links: "Links",
		addLink: "Link hinzufügen",
		removeLink: "Entfernen",
		linkNameHint: "Name des verwendeten Links.",
		linkUrlHint: "Geben Sie bei Bedarf den verwendeten Link an.",
		linkName: "Name",
		linkUrl: "URL",
		hintNamePlaceholder: "Beispiel: Relevante Nachrichten über den Markt",
		hintUrlPlaceholder: "Beispiel: https://www.relevantnews.com",
		cannotAddMore: "Kann nicht mehr hinzufügen",
		demandGenerationResources: "Nachfragegenerierungsressourcen",
		doYouWantToPreloadGlobalOfferData: "Möchten Sie das Formular mit Daten aus dem globalen Angebot vorab füllen?",
		doYouWantToPreloadGlobalSectorData: "Möchten Sie das Formular mit Daten aus der globalen Branchenpräsentation vorab füllen?",
		isCorporatePresentation: "Ist Unternehmenspräsentation",
		recognitions: 'Akkodis-Anerkennungen',
		recognitionsHint: "Sie können Anerkennungen hinzufügen, die mit diesem Angebot oder dieser Branchenpräsentation in Zusammenhang stehen, wie z.B. Auszeichnungen, Analystenanerkennungen usw.",
		recognitionsPlaceholder: "Wählen Sie eine oder mehrere Anerkennungen",
		uploadLogo: 'Logo hochladen',
		uploadResource: 'Ressource hochladen',
		recognitionDescription: 'Beispiel: ER&D Services und Digital Engineering',
		recognitionLinkHint: 'Anerkennungslink kann hinzugefügt werden, wenn keine Ressource hochgeladen ist. Wenn Sie einen Link hinzufügen möchten, entfernen Sie bitte die Ressource.',
		recognitionsWarning: 'Beachten Sie, dass eine unvollständige Anerkennung nicht gespeichert wird.',
		recognitionsWarningHint: "Eine unvollständige Anerkennung ist eine ohne Beschreibung, Logo oder hat keinen Link oder keine Datei.",
		addEditor: "Editor hinzufügen",
		removeEditor: "Entfernen",
		editors: "Editoren",
		editorsHint: "Geben Sie einer Person Rechte, die bearbeiten, speichern und einreichen kann.",
		editorPlaceholder: "Wählen Sie einen oder mehrere Editoren",
		editorsSubTitle: "Editor",
		footer: {
			contactUs: 'Kontaktieren Sie uns',
			reportProblem: "Problem melden",
			resources: "Ressourcen",
			contactCMT: 'Kontakt CMT'
		},
		confirmationRequired: 'Bestätigung erforderlich',
		projects: "Projekte",
		publishedProjects: 'Veröffentlichte Projekte',
		revenues: "Einnahmen",
		drafts: "Entwürfe",
		archived: "Archiviert",
		shared: "Geteilt",
		forReview: "Zur Überprüfung",
		surveyQuestions: "Umfragefragen",
		needHelp: 'Benötigen Sie Hilfe? Klicken Sie hier.',
		surveyName: "Umfragename",
		question: "Frage",
		deleteQuestion: "Frage löschen",
		addQuestion: "Frage hinzufügen",
		type: 'Typ',
		enterQuestionText: "Fragentext eingeben",
		answerText: "Antworttext",
		deleteAnswer: "Antwort löschen",
		answers: "Antworten",
		singleChoice: "Einzelauswahl",
		multipleChoice: "Mehrfachauswahl",
		textResponse: "Textantwort",
		addAnswer: "Antwort hinzufügen",
		createSurvey: "Umfrage erstellen",
		areYouSureYouWantToDeleteSurvey: "Sind Sie sicher, dass Sie die Umfrage löschen möchten?",
		saveSurvey: "Umfrage speichern",
		surveySaveSuccess: "Umfrage erfolgreich gespeichert.",
		surveyGetFailed: "Ein Problem ist aufgetreten, als versucht wurde, die Umfrage abzurufen. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich an das CMT-Team.",
		surveyNotValid: "Umfrage ist nicht gültig. Bitte überprüfen Sie die Fragen und Antworten.",
		errorSavingSurvey: "Fehler beim Speichern der Umfrage. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich an das CMT-Team.",
		delete: "Löschen",
		active: "Aktiv",
		setActive: "Aktiv setzen",
		activate: 'Aktivieren',
		deactivate: 'Deaktivieren',
		createVideo: "Video erstellen",
		wrongTypePleaseUploadVideo: "Falscher Dateityp! Bitte laden Sie eine Videodatei hoch.",
		hide: 'Verbergen',
		show: 'Anzeigen',
		deleteVideoMessage: "Sind Sie sicher, dass Sie dieses Video löschen möchten?",
		videoDeletedSuccessfully: "Video erfolgreich gelöscht.",
		successfullySavedVideo: "Video erfolgreich gespeichert.",
		wrongId: "Element existiert nicht. Bitte überprüfen Sie die URL.",
		fillAllFields: "Bitte füllen Sie alle Felder aus.",
		currentVideo: "Aktuelles Video",
		videoTitle: "Videotitel",
		videoDescription: "Videobeschreibung",
		confirmVideoTranslations: "Das Speichern überschreibt vorhandene Übersetzungen und wendet automatische Übersetzungen aus dem Englischen an. Sind Sie sicher, dass Sie fortfahren möchten?",
		successfullyCreatedVideo: "Video erfolgreich erstellt.",
		errorWhileSaving: "Fehler beim Speichern. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich an das CMT-Team.",
		deleteResourceFileMessage: "Sind Sie sicher, dass Sie diese Ressourcendatei löschen möchten?",
		resourceFileDeletedSuccessfully: "Ressourcendatei erfolgreich gelöscht.",
		successfullySavedResourceFile: "Ressourcendatei erfolgreich gespeichert.",
		currentResourceFile: "Aktuelle Ressourcendatei",
		resourceFileTitle: "Ressourcendatei Titel",
		resourceFileDescription: "Ressourcendatei Beschreibung",
		confirmResourceFileTranslations: "Das Speichern überschreibt vorhandene Übersetzungen und wendet automatische Übersetzungen aus dem Englischen an. Sind Sie sicher, dass Sie fortfahren möchten?",
		successfullyCreatedResourceFile: "Ressourcendatei erfolgreich erstellt.",
		createResourceFile: "Ressourcendatei erstellen",
		wrongTypePleaseUploadResourceFile: "Falscher Dateityp! Bitte laden Sie eine Ressourcendatei hoch.",
		downloadCurrentFile: "Aktuelle Datei herunterladen",
		createPromotion: "Promotion erstellen",
		deletePromotionMessage: "Sind Sie sicher, dass Sie diese Promotion löschen möchten?",
		promotionDeletedSuccessfully: "Promotion erfolgreich gelöscht.",
		pleaseSelectProject: "Bitte wählen Sie ein Projekt aus.",
		promotionCreatedSuccessfully: "Promotion erfolgreich erstellt.",
		increase: "Erhöhen",
		decrease: "Verringern",
		promotedUntil: "Beworben bis",
		selectAProjectForPromotion: "Wählen Sie ein Projekt für die Promotion aus",
		promote: "Bewerben",
		categoryLabel: "Kategorie",
		categoryPlaceholder: "Kategorie auswählen",
		categoryHint: "Wählen Sie eine Kategorie für diese Präsentation aus",
		doYouWantToSendEmailForNextPublishing: "Möchten Sie dem Eigentümer eine E-Mail senden, wenn das Projekt das nächste Mal veröffentlicht wird?",
		emailDisabledOnPublish: "Es wird KEINE E-Mail an den Eigentümer gesendet, wenn das Projekt das nächste Mal veröffentlicht wird.",
		sendEmail: "E-Mail senden?",
		annualRevenue: "Jahresumsatz",
		annualRevenueHint: "Geben Sie den aus diesem Projekt generierten Jahresumsatz ein",
		annualRevenuePlaceholder: "Jahresumsatz eingeben",
		maturity: "Reife",
		maturityHint: "Wählen Sie die Reifegradstufe dieses Projekts aus",
		maturityPlaceholder: "Reifegradstufe auswählen",
		confirmAndClose: "Bestätigen und schließen",
		startTour: "Tour starten",
		welcome: "Willkommen!",
		welcomeText: "Die neue Version von GOP ist jetzt verfügbar. Bitte wählen Sie Ihr Land aus, um Ihre Erfahrung zu personalisieren. Sie können eine kurze Tour starten, um zu entdecken, was neu ist, oder einfach bestätigen und schließen.",
		country: "Land",
		countryPlaceholder: "Auswählen",
		countryError: "Bitte wählen Sie ein Land aus, um fortzufahren.",
		recognition: "Anerkennung",
		titlePlaceholder: "Titel hier eingeben",
		file: 'Datei',
		fileHint: 'Laden Sie eine Datei hoch',
		logo: "Logo",
		logoHint: "Laden Sie ein Logo hoch",
		url: "URL",
		urlPlaceholder: "Geben Sie eine URL ein",
		region: "Region",
		regionPlaceholder: "Region auswählen",
		infoDatePlaceHolder: 'Wählen Sie das spezifische Jahr aus, das sich auf diese Anerkennung bezieht',
		badge: "Abzeichen",
		analysts: "Analysten",
		analystsPlaceholder: "Analysten auswählen",
		additionalLinks: "Zusätzliche Links",
		insights: "Einblicke",
		insightsPlaceholder: "Bitte geben Sie Einblicke in Bezug auf diese Anerkennung an, z. B. warum sie vergeben wurde, was sie für Akkodis bedeutet usw.",
		relatedPartnershipPresentations: "Verwandte Partnerschaftspräsentationen",
		relatedPartnershipPresentationsPlaceholder: "Wählen Sie eine oder mehrere verwandte Partnerschaftspräsentationen aus",
		relatedSectors: "Verwandte Branchenpräsentationen",
		relatedSectorsPlaceholder: "Wählen Sie eine oder mehrere verwandte Branchenpräsentationen aus",
		relatedSectorsHint: "Wählen Sie eine oder mehrere verwandte Branchenpräsentationen aus.",
		relatedOffers: "Verwandte Angebote",
		relatedOffersPlaceholder: "Wählen Sie ein oder mehrere verwandte Angebote aus",
		relatedOffersHint: "Wählen Sie ein oder mehrere verwandte Angebote aus",
		images: "Bilder",
		logoAndBadge: "Logo und Abzeichen",
		relatedAndImages: "Verwandte & Bilder",
		recognitionFileLabel: "Datei",
		recognitionFileHint: "Laden Sie eine Datei hoch. Sie können entweder eine URL ausfüllen oder eine Datei hochladen. Das Hochladen einer Datei überschreibt die URL mit der URL der hochgeladenen Datei",
		addCountrySectorItems: "Element hinzufügen",
		removeCountrySectorItems: "Element entfernen",
		countrySectorItems: "Länder- und Branchenelemente",
		countrySectorItemResultHint: "Anzahl des Länder- und Branchenelements, die neben dem Länderbild angezeigt wird",
		countrySectorItemTextHint: "Text, der neben dem Länderbild angezeigt wird",
		countrySectorItemResult: "Nummer",
		countrySectorItemText: "Text",
		countryImage: "Länderbild",
		countryImageHint: "Laden Sie ein Länderbild hoch, das auf der Seite der Länderpräsentation neben den Länderelementen angezeigt wird",
		recognitionGalleryUploadGroupHint: "Galerie für Anerkennungen hochladen. Sie können Bilder im Zusammenhang mit der Anerkennung hochladen, z. B. Fotos von der Preisverleihung, Bilder der Auszeichnung selbst usw.",
		videoLinks: "Video-Links",
		videoHintNamePlaceholder: 'Beispiel: "Relevante Nachrichten über den Markt"',
		videoHintUrlPlaceholder: 'Beispiel: "https://www.example.com"',
		countries: "Länder",
		infoDate: "Jahr",
		marketData: 'Marktdaten'
	},
	[LANGUAGE.fr.short]: {
		areYouSure: "Es-tu sûr?",
		confirmAction: "Confirmer l'action",
		areYouSureYouWantToUnpublish: "Êtes-vous sûr de vouloir annuler la publication",
		areYouSureYouWantToArchive: "Êtes-vous sûr de vouloir archiver",
		areYouSureYouWantToReturnProjectToDraft: "Êtes-vous sûr de vouloir renvoyer le projet au RO ?",
		areYouSureYouWantToRejectProject: "Êtes-vous sûr de vouloir rejeter le projet ?",
		areYouSureYouWantToDeleteProject: "Êtes-vous sûr de vouloir supprimer le projet ?",
		areYouSureYouWantToUnarchiveProject: "Êtes-vous sûr de vouloir restaurer le projet ?",
		areYouSureYouWantToArchiveProject: "Êtes-vous sûr de vouloir archiver le projet ?",
		theProject: "le projet",
		yes: 'Oui',
		no: "Non",
		ok: 'OK',
		websiteUnderMaintenance: "Site en maintenance",
		weAreImprovingWebsite: "Nous améliorons notre site Web. Nous serons de retour bientôt",
		startYear: "Année de début",
		startMonth: "Mois de début",
		endYear: "Année de fin",
		endMonth: "Mois de fin",
		year: "Année",
		month: "Mois",
		day: "Jour",
		denying: "Niant",
		deny: "Refuser",
		cancel: "Annuler",
		approving: "approuvant",
		approve: "Approuver",
		save: "Enregistrer",
		preview: "Aperçu",
		edit: "Modifier",
		loading: "Chargement",
		yourSessionHasExpired: "Votre session a expiré",
		pleaseLoginAgain: "Veuillez vous reconnecter après:",
		youWillBeLoggedOutIn: "Vous allez être déconnecté.",
		backToRO: "Retour à RO",
		rejectButton: "Rejeter",
		reasons: "Veuillez écrire ci-dessous les raisons du retour.",
		reasonsForRejecting: "Veuillez écrire ci-dessous les raisons du refus.",
		writeHere: "Écrivez le texte ici",
		commonPopupPlaceholder: "Écrivez votre texte ici",
		commonPopupError: "Le champ de texte est obligatoire.",
		name: "Nom",
		intro: "Introduction",
		offerPresentation: "Présentation de l'offre",
		presentationAndVideoLink: "Présentation et lien vidéo",
		globalOwners: "Propriétaires",
		akkodisExpertise: "Expertise Akkodis",
		marketInsights: "Perspectives du marché",
		clientNeedsAndBenefits: "Besoins et avantages des clients",
		tipsAndTricks: "Trucs et astuces",
		referencesAndSuccessStories: "Références et success stories",
		actions: 'Actions',
		validate: 'Valider',
		backToTop: 'Retour en haut',
		submit: 'Soumettre',
		presentationType: 'Présentation du secteur ou de l’offre',
		presentationTypeSector: 'Secteur',
		presentationTypeOffer: 'Offre',
		title: 'Titre',
		presentationTitleHere: 'Titre de la présentation ici',
		thumbnail: 'Vignette',
		thumbnailHint: "Résolution : égale ou supérieure à 300x200px. Ratio : rectangulaire 3:2",
		panoramicPhoto: 'Photo panoramique',
		panoramicPhotoHint: "Résolution: 1920x535px ou 1200x338px.",
		description: 'Description',
		descriptionPlaceholder: 'Veuillez fournir des informations de base sur la présentation de l’offre ou du secteur. Les raisons et le contexte de celle-ci, la valeur ajoutée pour le client.',
		descriptionHint: "Veuillez fournir des informations de base sur la présentation de l’offre ou du secteur. Les raisons et le contexte de celle-ci, la valeur ajoutée pour le client. Environ 600-800 caractères avec espaces.",
		deliveryLocation: 'Lieu de livraison',
		deliveryLocationPlaceholder: "Sélectionnez un ou plusieurs pays",
		singleDeliveryLocationPlaceholder: "Sélectionnez un pays",
		deliveryLocationHint: "Listez tous les pays où les activités associées à l'offre pourraient être livrées",
		length: "Longueur",
		ftes: "ETP",
		ftesHint: "Entrez le nombre d'employés d'Akkodis impliqués dans cette activité",
		presentationPPT: "Version de présentation PPT",
		presentationPPTHint: "Téléchargez la version PPT de la présentation (anglais uniquement)",
		presentationPDF: "Version de présentation PDF",
		presentationPDFHint: "Téléchargez la version PDF de la présentation (anglais uniquement)",
		email: "Email",
		globalOwnersNameHint: 'Le propriétaire ne sera visible qu’en interne dans GOP. Ils ne seront pas visibles dans les documents externes.',
		globalOwnersEmailHint: 'Le propriétaire ne sera visible qu’en interne dans GOP. Ils ne seront pas visibles dans les documents externes.',
		globalOwnersNamePlaceholder: "Exemple : John Silverman",
		globalOwnersEmailPlaceholder: "Exemple : JohnSilverman@akkodis.com",
		globalOwnersSubTitle: "Propriétaire",
		addItem: "Ajouter un élément",
		removeItem: "Supprimer l'élément",
		addGlobalOwner: "Ajouter un propriétaire",
		removeGlobalOwner: "Supprimer le propriétaire",
		videoLink: "Lien vidéo",
		videoLinkHint: "Vous pouvez partager des liens externes vers des vidéos liées à la présentation du secteur ou de l’offre",
		videoLinkPlaceholder: "URL de la vidéo...",
		projectIndustry: "Industrie du projet",
		projectIndustryHint: "Vous ne pouvez sélectionner qu'une seule industrie pour cette présentation d'offre ou de secteur. Non disponible pour les présentations d'entreprise",
		serviceLines: "Type d'activité",
		serviceLinesHint: "Vous pouvez sélectionner plusieurs types d'activité pour cette offre ou présentation sectorielle.",
		techPractices: "Pratiques technologiques",
		techPracticesHint: "Vous pouvez choisir plus d'une pratique technologique pour cette présentation d'offre ou de secteur",
		mainClientPersona: "Persona client principal",
		mainClientPersonaHint: "Vous pouvez choisir plus d'une persona client principal pour cette présentation d'offre ou de secteur",
		mainClientPersonaPlaceholder: "Sélectionnez un ou plusieurs domaines",
		lifecycle: "Cycle de vie",
		lifecycleHint: "Vous pouvez choisir plus d'un cycle de vie pour cette présentation d'offre ou de secteur",
		lifecyclePlaceholder: "Sélectionnez une ou plusieurs parties du cycle de vie",
		toolsAndSystems: "Outils et systèmes",
		toolsAndSystemsHint: "Matériel et logiciel utilisés par l'équipe et technologies utilisées. Lorsque vous ajoutez un nouvel outil qui n'est pas dans les options fournies, la couleur de fond de celui-ci sera jaune. Après approbation, l'arrière-plan redeviendra bleu",
		toolsAndSystemsPlaceholder: "Sélectionnez un ou plusieurs outils et systèmes",
		certifications: "Certifications",
		certificationsHint: "Normes, méthodologies et cadres utilisés. Lorsque vous ajoutez une nouvelle certification qui n'est pas dans les options fournies, la couleur de fond de celle-ci sera jaune. Après approbation, l'arrière-plan redeviendra bleu",
		certificationsPlaceholder: "Sélectionnez une ou plusieurs certifications",
		largestMarket: "Plus grand marché",
		largestMarketHint: "Sélectionnez les pays du plus grand marché",
		largestMarketPlaceholder: "Sélectionnez un ou plusieurs pays",
		fastestGrowingMarket: "Marché à la croissance la plus rapide",
		fastestGrowingMarketHint: "Sélectionnez les pays du marché à la croissance la plus rapide",
		fastestGrowingMarketPlaceholder: "Sélectionnez un ou plusieurs pays",
		biggestMarketConclusion: "Conclusion du plus grand marché",
		biggestMarketConclusionHint: "Vous pouvez fournir des informations de conclusion sur la section des plus grands marchés. Environ 150-250 caractères avec espaces.",
		biggestMarketConclusionPlaceholder: "Exemple : Valeur de la taille du marché en 2022 USD 285 millions",
		keyMarketDrivers: "Principaux moteurs de marché",
		keyMarketDriversHint: "Veuillez fournir des informations sur les principaux moteurs de marché. Environ 400-600 caractères avec espaces.",
		keyMarketDriversPlaceholder: "Veuillez fournir des informations sur les principaux moteurs de marché.",
		marketOpportunities: "Opportunités de marché",
		marketOpportunitiesHint: "Veuillez fournir des informations sur les opportunités de marché. Environ 400-600 caractères avec espaces.",
		marketOpportunitiesPlaceholder: "Veuillez fournir des informations sur les opportunités de marché.",
		clientNeeds: "Besoins des clients",
		clientNeedsHint: "Veuillez fournir des informations sur les besoins des clients. Environ 400-600 caractères avec espaces.",
		clientNeedsPlaceholder: "Message.",
		clientBenefits: "Avantages pour les clients",
		clientBenefitsHint: "Veuillez fournir des informations sur les avantages pour les clients. Environ 400-600 caractères avec espaces.",
		clientBenefitsPlaceholder: "Message.",
		tips: "Conseils",
		tipsHint: "Veuillez fournir des informations sur les besoins des clients. Environ 600-800 caractères avec espaces.",
		tipsPlaceholder: "Message.",
		keyHighlights: "Points forts",
		keyHighlightsHint: "Veuillez fournir des informations sur les points forts. Environ 400-600 caractères avec espaces.",
		keyHighlightsPlaceholder: "Veuillez fournir des informations sur les principaux moteurs de marché.",
		additionalNotes: "Notes supplémentaires",
		additionalNotesHint: "Si nécessaire, ajoutez des notes supplémentaires pour les parties prenantes qui prendront en charge la présentation de cette offre ou de la présentation du secteur. Environ 400-600 caractères.",
		additionalNotesPlaceholder: "Veuillez fournir des informations sur les principaux moteurs de marché.",
		competitors: "Concurrents",
		competitorsHint: "Sélectionnez les concurrents d'Akkodis sur le marché. Lorsque vous ajoutez un nouveau concurrent qui n'est pas dans les options fournies, la couleur de fond de celui-ci sera jaune. Après approbation, l'arrière-plan redeviendra bleu",
		competitorsPlaceholder: "Sélectionnez un ou plusieurs concurrents.",
		addReference: "Ajouter une référence",
		removeReference: "Supprimer",
		references: "Références",
		referenceDescription: "Description",
		referenceDescriptionHint: "Si nécessaire, fournissez des informations sur la référence utilisée.",
		referenceDescriptionPlaceholder: "Exemple : HFS Horizons: Generative Enterprise Services, 2023.",
		referenceUrl: "URL",
		referenceUrlHint: "Si nécessaire, fournissez la référence utilisée.",
		referenceUrlPlaceholder: "Exemple : https://www.hfsresearch.com/Generative-enterprise-2023",
		pleaseWait: "Veuillez patienter...",
		language: "Choisir la langue",
		languageHint: "Lorsque vous soumettez dans une autre langue, votre offre ou présentation de secteur sera automatiquement traduite en anglais.",
		languagePlaceholder: "Veuillez choisir la langue dans laquelle vous souhaitez soumettre votre offre ou présentation de secteur",
		copyUrlSuccess: "L'URL a été copiée avec succès.",
		akkodisAndIndustryPresentation: "Akkodis, Présentations de l'industrie et des pratiques",
		sectorPresentation: "Présentation de l'industrie",
		generalPresentation: "Présentation générale",
		mainTechPractice: "Principale pratique technologique",
		mainGlobalOwner: "Propriétaire principal",
		mainGlobalOwnerPlaceholder: "Sélectionner un propriétaire principal",
		mainGlobalOwnerHint: "Vous ne pouvez choisir qu'un seul propriétaire principal",
		mainTechPracticeHint: "Vous ne pouvez choisir qu'une seule pratique technologique principale",
		mainTechPracticePlaceholder: "Sélectionnez une pratique technologique",
		mainProjectIndustry: "Principale industrie du projet",
		mainProjectIndustryHint: "Vous ne pouvez choisir qu'une seule industrie de projet principale. Non disponible pour les présentations d'entreprise",
		mainProjectIndustryPlaceholder: "Sélectionnez une industrie de projet",
		mobilePanoramicPhoto: 'Photo panoramique mobile',
		mobilePanoramicPhotoHint: "Résolution : 480x400px ou 460x400px",
		doYouWantToProceedWithSubmit: "Voulez-vous continuer? Vous avez toujours des champs vides.",
		emptyFields: "Champs vides",
		referenceStory: "Histoire de référence",
		offerType: "Type d'offre",
		offerTypeLabel: "Choisir le type",
		offerTypeHint: "Veuillez sélectionner le type d'offre que vous soumettez",
		offerTypePlaceholder: "Veuillez choisir le type d'offre que vous souhaitez",
		globalOffer: "Offre parent",
		globalOfferHint: "Veuillez sélectionner l'offre parent pour cette offre",
		globalOfferPlaceholder: "Veuillez choisir le parent de l'offre localisée",
		deliveryLocationDisabledHint: "Pays indisponible, en raison de l'existence d'une offre localisée concernant ce pays",
		local: "Local",
		global: "Global",
		localized: "Localisé",
		relatedOffersByContent: "Offres connexes par contenu",
		relatedSectorsByContent: "Présentations de secteurs connexes par contenu",
		relatedPresentationsByContent: "CONTENU ASSOCIÉ",
		english: "Anglais",
		french: "Français",
		german: "Allemand",
		italian: "Italien",
		japanese: "Japonais",
		spanish: "Espagnol",
		noTitle: "Pas de titre",
		noRelatedOffers: "Pas d'offres connexes",
		noRelatedSectors: "Pas de présentations de secteurs connexes",
		originalTranslation: "TRADUCTION ORIGINALE",
		for: "pour",
		addOffer: "Ajouter une offre",
		removeOffer: "Supprimer",
		offerReferences: "Offres connexes",
		offerLabel: "Offre",
		offerPlaceholder: "Sélectionnez une offre connexe",
		offerLabelEn: "Offres en anglais",
		offerHintEn: "Sélectionnez une ou plusieurs offres connexes en anglais",
		offerPlaceholderEn: "Sélectionnez une ou plusieurs offres connexes en anglais",
		offerLabelFr: "Offres en français",
		offerHintFr: "Sélectionnez une ou plusieurs offres connexes en français",
		offerPlaceholderFr: "Sélectionnez une ou plusieurs offres connexes en français",
		offerLabelDe: "Offres en allemand",
		offerHintDe: "Sélectionnez une ou plusieurs offres connexes en allemand",
		offerPlaceholderDe: "Sélectionnez une ou plusieurs offres connexes en allemand",
		offerLabelIt: "Offres en italien",
		offerHintIt: "Sélectionnez une ou plusieurs offres connexes en italien",
		offerPlaceholderIt: "Sélectionnez une ou plusieurs offres connexes en italien",
		offerLabelJa: "Offres en japonais",
		offerHintJa: "Sélectionnez une ou plusieurs offres connexes en japonais",
		offerPlaceholderJa: "Sélectionnez une ou plusieurs offres connexes en japonais",
		offerLabelEs: "Offres en espagnol",
		offerHintEs: "Sélectionnez une ou plusieurs offres connexes en espagnol",
		offerPlaceholderEs: "Sélectionnez une ou plusieurs offres connexes en espagnol",
		sectorType: "Type de présentation",
		sectorTypeLabel: "Choisir le type",
		sectorTypeHint: "Veuillez sélectionner le type de présentation que vous soumettez",
		sectorTypePlaceholder: "Veuillez choisir le type de présentation que vous souhaitez",
		globalSectors: "Présentation parent",
		globalSectorHint: "Veuillez sélectionner le parent pour cette présentation",
		globalSectorPlaceholder: "Veuillez choisir le parent de la présentation localisée",
		sectorReferences: "Présentations connexes",
		sectorLabelEn: "Présentations en anglais",
		sectorHintEn: "Sélectionnez une ou plusieurs présentations connexes en anglais",
		sectorPlaceholderEn: "Sélectionnez une ou plusieurs présentations connexes en anglais",
		sectorLabelFr: "Présentations en français",
		sectorHintFr: "Sélectionnez une ou plusieurs présentations connexes en français",
		sectorPlaceholderFr: "Sélectionnez une ou plusieurs présentations connexes en français",
		sectorLabelDe: "Présentations en allemand",
		sectorHintDe: "Sélectionnez une ou plusieurs présentations connexes en allemand",
		sectorPlaceholderDe: "Sélectionnez une ou plusieurs présentations connexes en allemand",
		sectorLabelIt: "Présentations en italien",
		sectorHintIt: "Sélectionnez une ou plusieurs présentations connexes en italien",
		sectorPlaceholderIt: "Sélectionnez une ou plusieurs présentations connexes en italien",
		sectorLabelJa: "Présentations en japonais",
		sectorHintJa: "Sélectionnez une ou plusieurs présentations connexes en japonais",
		sectorPlaceholderJa: "Sélectionnez une ou plusieurs présentations connexes en japonais",
		sectorLabelEs: "Présentations en espagnol",
		sectorHintEs: "Sélectionnez une ou plusieurs présentations connexes en espagnol",
		sectorPlaceholderEs: "Sélectionnez une ou plusieurs présentations connexes en espagnol",
		resources: "Ressources",
		resourcesHint: "Vous pouvez choisir plus d'une ressource pour cette présentation d'offre ou de secteur",
		resourcesPlaceholder: "Sélectionnez une ou plusieurs ressources",
		link: "Lien",
		links: "Liens",
		addLink: "Ajouter un lien",
		removeLink: "Supprimer",
		linkNameHint: "Nom du lien utilisé.",
		linkUrlHint: "Si nécessaire, indiquez le lien utilisé.",
		linkName: "Nom",
		linkUrl: "URL",
		hintNamePlaceholder: "Exemple : Actualités pertinentes sur le marché",
		hintUrlPlaceholder: "Exemple : https://www.relevantnews.com",
		cannotAddMore: "Impossible d'ajouter plus",
		demandGenerationResources: "RESSOURCES SUPPLÉMENTAIRES",
		doYouWantToPreloadGlobalOfferData: "Voulez-vous précharger les données de l'offre mondiale dans le formulaire?",
		doYouWantToPreloadGlobalSectorData: "Voulez-vous précharger les données de la présentation de l'industrie mondiale dans le formulaire?",
		isCorporatePresentation: "Présentation d'entreprise",
		recognitionsHint: "Vous pouvez ajouter des reconnaissances liées à cette présentation d'offre ou de secteur, telles que des récompenses, des reconnaissances d'analystes, etc.",
		recognitionsPlaceholder: "Sélectionnez une ou plusieurs reconnaissances",
		recognitions: 'Récompenses Akkodis',
		uploadLogo: 'Télécharger le logo',
		uploadResource: 'Télécharger la ressource',
		recognitionDescription: 'Exemple : Services ER&D et ingénierie numérique',
		recognitionLinkHint: 'Le lien de reconnaissance peut être ajouté si aucune ressource n’est téléchargée. Si vous souhaitez ajouter un lien, veuillez supprimer la ressource.',
		recognitionsWarning: 'Veuillez noter qu’une reconnaissance incomplète ne sera pas enregistrée.',
		recognitionsWarningHint: "Une reconnaissance incomplète est une reconnaissance sans description, sans logo ou sans lien ou fichier.",
		addEditor: "Ajouter un éditeur",
		removeEditor: "Supprimer",
		editors: "Éditeurs",
		editorsHint: "Donnez à une personne les droits de modifier, enregistrer et soumettre.",
		editorPlaceholder: "Sélectionnez un ou plusieurs éditeurs",
		editorsSubTitle: "Éditeur",
		footer: {
			contactUs: 'Contactez-nous',
			reportProblem: "Signaler un problème",
			resources: "Ressources",
			contactCMT: 'Contactez CMT'
		},
		confirmationRequired: 'Confirmation requise',
		projects: "Projets",
		publishedProjects: 'Projets publiés',
		revenues: "Revenus",
		drafts: "Brouillons",
		archived: "Archivé",
		shared: "Partagé",
		forReview: "Pour révision",
		surveyQuestions: "Questions d'enquête",
		needHelp: 'Besoin d\'aide? Cliquez ici.',
		surveyName: "Nom de l'enquête",
		question: "Question",
		deleteQuestion: "Supprimer la question",
		addQuestion: "Ajouter une question",
		type: 'Type',
		enterQuestionText: "Entrez le texte de la question",
		answerText: "Texte de la réponse",
		deleteAnswer: "Supprimer la réponse",
		answers: "Réponses",
		singleChoice: "Choix unique",
		multipleChoice: "Choix multiple",
		textResponse: "Réponse textuelle",
		addAnswer: "Ajouter une réponse",
		createSurvey: "Créer une enquête",
		areYouSureYouWantToDeleteSurvey: "Êtes-vous sûr de vouloir supprimer l'enquête ?",
		saveSurvey: "Enregistrer l'enquête",
		surveySaveSuccess: "Enquête enregistrée avec succès.",
		surveyGetFailed: "Un problème est survenu lors de la récupération de l'enquête. Veuillez réessayer. Si le problème persiste, veuillez contacter l'équipe CMT.",
		surveyNotValid: "L'enquête n'est pas valide. Veuillez vérifier les questions et les réponses.",
		errorSavingSurvey: "Erreur lors de l'enregistrement de l'enquête. Veuillez réessayer. Si le problème persiste, veuillez contacter l'équipe CMT.",
		delete: "Supprimer",
		active: "Actif",
		setActive: "Définir comme actif",
		activate: 'Activer',
		deactivate: 'Désactiver',
		createVideo: "Créer une vidéo",
		wrongTypePleaseUploadVideo: "Type de fichier incorrect! Veuillez télécharger un fichier vidéo.",
		hide: 'Masquer',
		show: 'Afficher',
		deleteVideoMessage: "Êtes-vous sûr de vouloir supprimer cette vidéo?",
		videoDeletedSuccessfully: "Vidéo supprimée avec succès.",
		successfullySavedVideo: "Vidéo enregistrée avec succès.",
		wrongId: "L'élément n'existe pas. Veuillez vérifier l'URL.",
		fillAllFields: "Veuillez remplir tous les champs.",
		currentVideo: "Vidéo actuelle",
		videoTitle: "Titre de la vidéo",
		videoDescription: "Description de la vidéo",
		confirmVideoTranslations: "L'enregistrement écrasera les traductions existantes et appliquera des traductions automatiques de l'anglais. Êtes-vous sûr de vouloir continuer?",
		successfullyCreatedVideo: "Vidéo créée avec succès.",
		errorWhileSaving: "Erreur lors de l'enregistrement. Veuillez réessayer. Si le problème persiste, veuillez contacter l'équipe CMT.",
		deleteResourceFileMessage: "Êtes-vous sûr de vouloir supprimer ce fichier de ressources?",
		resourceFileDeletedSuccessfully: "Fichier de ressources supprimé avec succès.",
		successfullySavedResourceFile: "Fichier de ressources enregistré avec succès.",
		currentResourceFile: "Fichier de ressources actuel",
		resourceFileTitle: "Titre du fichier de ressources",
		resourceFileDescription: "Description du fichier de ressources",
		confirmResourceFileTranslations: "L'enregistrement écrasera les traductions existantes et appliquera des traductions automatiques de l'anglais. Êtes-vous sûr de vouloir continuer?",
		successfullyCreatedResourceFile: "Fichier de ressources créé avec succès.",
		createResourceFile: "Créer un fichier de ressources",
		wrongTypePleaseUploadResourceFile: "Type de fichier incorrect! Veuillez télécharger un fichier de ressources.",
		downloadCurrentFile: "Télécharger le fichier actuel",
		createPromotion: "Créer une promotion",
		deletePromotionMessage: "Êtes-vous sûr de vouloir supprimer cette promotion?",
		promotionDeletedSuccessfully: "Promotion supprimée avec succès.",
		pleaseSelectProject: "Veuillez sélectionner un projet.",
		promotionCreatedSuccessfully: "Promotion créée avec succès.",
		increase: "Augmenter",
		decrease: "Diminuer",
		promotedUntil: "Promu jusqu'à",
		selectAProjectForPromotion: "Sélectionnez un projet pour la promotion",
		promote: "Promouvoir",
		categoryLabel: "Catégorie",
		categoryPlaceholder: "Sélectionner une catégorie",
		categoryHint: "Sélectionnez une catégorie pour cette présentation",
		doYouWantToSendEmailForNextPublishing: "Voulez-vous envoyer un e-mail au propriétaire lorsque le projet sera publié la prochaine fois?",
		emailDisabledOnPublish: "AUCUN e-mail ne sera envoyé au propriétaire lorsque le projet sera publié la prochaine fois.",
		sendEmail: "Envoyer un e-mail?",
		annualRevenue: "Revenu annuel",
		annualRevenueHint: "Entrez le revenu annuel généré par ce projet",
		annualRevenuePlaceholder: "Entrez le revenu annuel",
		maturity: "Maturité",
		maturityHint: "Sélectionnez le niveau de maturité de ce projet",
		maturityPlaceholder: "Sélectionnez le niveau de maturité",
		confirmAndClose: "Confirmer et fermer",
		startTour: "Commencer la visite",
		welcome: "Bienvenue!",
		welcomeText: "La nouvelle version de GOP est maintenant disponible. Veuillez sélectionner votre pays pour personnaliser votre expérience. Vous pouvez démarrer une courte visite pour découvrir les nouveautés ou simplement confirmer et fermer.",
		country: "Pays",
		countryPlaceholder: "Sélectionner",
		countryError: "Veuillez sélectionner un pays pour continuer.",
		recognition: "Reconnaissance",
		titlePlaceholder: "Entrez le titre ici",
		file: 'Fichier',
		fileHint: 'Téléchargez un fichier',
		logo: "Logo",
		logoHint: "Téléchargez un logo",
		url: "URL",
		urlPlaceholder: "Entrez une URL",
		region: "Région",
		regionPlaceholder: "Sélectionner une région",
		infoDatePlaceHolder: 'Sélectionnez l\'année spécifique liée à cette reconnaissance',
		badge: "Badge",
		analysts: "Analystes",
		analystsPlaceholder: "Sélectionner des analystes",
		additionalLinks: "Liens supplémentaires",
		insights: "Perspectives",
		insightsPlaceholder: "Veuillez fournir des perspectives liées à cette reconnaissance, telles que pourquoi elle a été décernée, ce qu'elle signifie pour Akkodis, etc.",
		relatedPartnershipPresentations: "Présentations de partenariats connexes",
		relatedPartnershipPresentationsPlaceholder: "Sélectionnez une ou plusieurs présentations de partenariats connexes",
		relatedSectors: "Présentations de secteurs connexes",
		relatedSectorsPlaceholder: "Sélectionnez une ou plusieurs présentations de secteurs connexes",
		relatedSectorsHint: "Sélectionnez une ou plusieurs présentations de secteurs connexes.",
		relatedOffers: "Offres connexes",
		relatedOffersPlaceholder: "Sélectionnez une ou plusieurs offres connexes",
		relatedOffersHint: "Sélectionnez une ou plusieurs offres connexes",
		images: "Images",
		logoAndBadge: "Logo et badge",
		relatedAndImages: "Connexes & Images",
		recognitionFileLabel: "Fichier",
		recognitionFileHint: "Téléchargez un fichier. Vous pouvez soit remplir une URL, soit télécharger un fichier. Le téléchargement d'un fichier écrasera l'URL avec l'URL du fichier téléchargé",
		addCountrySectorItems: "Ajouter un élément",
		removeCountrySectorItems: "Supprimer un élément",
		countrySectorItems: "Éléments de pays et de secteur",
		countrySectorItemResultHint: "Nombre d'éléments de pays et de secteur à afficher à côté de l'image du pays sur la page de présentation du pays",
		countrySectorItemTextHint: "Texte à afficher à côté de l'image du pays sur la page de présentation du pays",
		countrySectorItemResult: "Numéro",
		countrySectorItemText: "Texte",
		countryImage: "Image du pays",
		countryImageHint: "Téléchargez une image du pays à afficher sur la page de présentation du pays à côté des éléments de pays",
		recognitionGalleryUploadGroupHint: "Téléchargez une galerie pour les reconnaissances. Vous pouvez télécharger des images liées à la reconnaissance, telles que des photos de la cérémonie de remise des prix, des images de la récompense elle-même, etc.",
		videoLinks: "Liens vidéo",
		videoHintNamePlaceholder: 'Exemple : "Actualités pertinentes sur le marché"',
		videoHintUrlPlaceholder: 'Exemple : "https://www.example.com"',
		countries: "Pays",
		infoDate: "Année",
		marketData: 'Données de marché'
	},
	[LANGUAGE.it.short]: {
		areYouSure: "Sei sicuro?",
		confirmAction: "Conferma l'azione",
		areYouSureYouWantToUnpublish: "Sei sicuro di voler annullare la pubblicazione?",
		areYouSureYouWantToArchive: "Sei sicuro di voler archiviare",
		areYouSureYouWantToReturnProjectToDraft: "Sei sicuro di voler restituire il progetto al RO?",
		areYouSureYouWantToRejectProject: "Sei sicuro di voler rifiutare il progetto?",
		areYouSureYouWantToDeleteProject: "Sei sicuro di voler eliminare il progetto?",
		areYouSureYouWantToUnarchiveProject: "Sei sicuro di voler ripristinare il progetto?",
		areYouSureYouWantToArchiveProject: "Sei sicuro di voler archiviare il progetto?",
		theProject: "il progetto",
		yes: 'SÌ',
		no: "No",
		ok: 'OK',
		websiteUnderMaintenance: "Sito in manutenzione",
		weAreImprovingWebsite: "Stiamo migliorando il nostro sito web. Torneremo presto",
		startYear: "Anno di inizio",
		startMonth: "Mese di inizio",
		endYear: "Anno di fine",
		endMonth: "Mese di fine",
		year: "Anno",
		month: "Mese",
		day: "Giorno",
		denying: "Negare",
		deny: "Negare",
		cancel: "Annulla",
		approving: "Approvando",
		approve: "Approvare",
		save: "Salvare",
		preview: "Anteprima",
		edit: "Modifica",
		loading: "Caricamento",
		yourSessionHasExpired: "La tua sessione è scaduta",
		pleaseLoginAgain: "Effettua nuovamente l'accesso dopo:",
		youWillBeLoggedOutIn: "Verrai disconnesso.",
		backToRO: "Torniamo a RO",
		rejectButton: "Rifiutare",
		reasons: "Si prega di scrivere qui sotto i motivi del reso.",
		reasonsForRejecting: "Si prega di scrivere qui sotto i motivi del rifiuto.",
		writeHere: "Scrivi qui il testo",
		commonPopupPlaceholder: "Scrivi qui il tuo testo",
		commonPopupError: "Il campo di testo è obbligatorio.",
		name: "Nome",
		intro: "Introduzione",
		offerPresentation: "Presentazione dell'offerta",
		presentationAndVideoLink: "Presentazione e collegamento video",
		globalOwners: "Proprietari",
		akkodisExpertise: "Competenza Akkodis",
		marketInsights: "Informazioni di mercato",
		clientNeedsAndBenefits: "Esigenze e vantaggi del cliente",
		tipsAndTricks: "Suggerimenti e trucchi",
		referencesAndSuccessStories: "Riferimenti e storie di successo",
		actions: 'Azioni',
		validate: 'Convalidare',
		backToTop: 'Torna in cima',
		submit: 'Invia',
		presentationType: 'Presentazione del settore o dell’offerta',
		presentationTypeSector: 'Settore',
		presentationTypeOffer: 'Offerta',
		title: 'Titolo',
		presentationTitleHere: 'Titolo della presentazione qui',
		thumbnail: 'Miniatura',
		thumbnailHint: "Risoluzione: uguale o maggiore di 300x200px. Rapporto: rettangolare 3:2",
		panoramicPhoto: 'Foto panoramica',
		panoramicPhotoHint: "Risoluzione: 1920x535px o 1200x338px.",
		description: 'Descrizione',
		descriptionPlaceholder: 'Fornisci informazioni di base sulla presentazione dell’offerta o del settore. Le ragioni e il contesto di questo, il valore aggiunto per il cliente.',
		descriptionHint: "Fornisci informazioni di base sulla presentazione dell’offerta o del settore. Le ragioni e il contesto di questo, il valore aggiunto per il cliente. Circa 600-800 caratteri con spazi.",
		deliveryLocation: 'Luogo di consegna',
		deliveryLocationPlaceholder: "Seleziona uno o più paesi",
		singleDeliveryLocationPlaceholder: "Seleziona un paese",
		deliveryLocationHint: "Elenca tutti i paesi in cui possono essere effettuate attività associate all'offerta",
		length: "Lunghezza",
		ftes: "FTE",
		ftesHint: "Inserisci il numero di dipendenti di Akkodis coinvolti in questa attività",
		presentationPPT: "Versione di presentazione PPT",
		presentationPPTHint: "Carica la versione PPT della presentazione (solo lingua inglese)",
		presentationPDF: "Versione di presentazione PDF",
		presentationPDFHint: "Carica la versione PDF della presentazione (solo lingua inglese)",
		email: "Email",
		globalOwnersNameHint: 'Il proprietario sarà visibile solo internamente in GOP. Non saranno visibili nei documenti esterni.',
		globalOwnersEmailHint: 'Il proprietario sarà visibile solo internamente in GOP. Non saranno visibili nei documenti esterni.',
		globalOwnersNamePlaceholder: "Esempio: John Silverman",
		globalOwnersEmailPlaceholder: "Esempio: JohnSilverman@akkodis.com",
		globalOwnersSubTitle: "Proprietario",
		addItem: "Aggiungi elemento",
		removeItem: "Rimuovi elemento",
		addGlobalOwner: "Aggiungi proprietario",
		removeGlobalOwner: "Rimuovi proprietario",
		videoLink: "Collegamento video",
		videoLinkHint: "È possibile condividere collegamenti esterni a video relativi alla presentazione del settore o dell’offerta",
		videoLinkPlaceholder: "URL del video...",
		projectIndustry: "Industria del progetto",
		projectIndustryHint: "Puoi selezionare solo un'industria per questa presentazione dell'offerta o del settore. Non disponibile per le presentazioni aziendali",
		serviceLines: "Tipologia di attività",
		serviceLinesHint: "È possibile scegliere più di una tipologia di attività per questa offerta o presentazione di settore",
		techPractices: "Pratiche tecniche",
		techPracticesHint: "È possibile scegliere più di una pratica tecnica per questa presentazione dell’offerta o del settore",
		mainClientPersona: "Persona cliente principale",
		mainClientPersonaHint: "È possibile scegliere più di una persona cliente principale per questa presentazione dell’offerta o del settore",
		mainClientPersonaPlaceholder: "Seleziona uno o più domini",
		lifecycle: "Ciclo di vita",
		lifecycleHint: "È possibile scegliere più di un ciclo di vita per questa presentazione dell’offerta o del settore",
		lifecyclePlaceholder: "Seleziona una o più parti del ciclo di vita",
		toolsAndSystems: "Strumenti e sistemi",
		toolsAndSystemsHint: "Hardware e software utilizzati dal team e tecnologie utilizzate. Quando si aggiunge un nuovo strumento che non è nelle opzioni fornite, il colore di sfondo di esso sarà giallo. Dopo l'approvazione, lo sfondo tornerà blu",
		toolsAndSystemsPlaceholder: "Seleziona uno o più strumenti e sistemi",
		certifications: "Certificazioni",
		certificationsHint: "Standard, metodologie e framework utilizzati. Quando si aggiunge una nuova certificazione che non è nelle opzioni fornite, il colore di sfondo di essa sarà giallo. Dopo l'approvazione, lo sfondo tornerà blu",
		certificationsPlaceholder: "Seleziona una o più certificazioni",
		largestMarket: "Mercato più grande",
		largestMarketHint: "Seleziona i paesi nel mercato più grande",
		largestMarketPlaceholder: "Seleziona uno o più paesi",
		fastestGrowingMarket: "Mercato in più rapida crescita",
		fastestGrowingMarketHint: "Seleziona i paesi nel mercato in più rapida crescita",
		fastestGrowingMarketPlaceholder: "Seleziona uno o più paesi",
		biggestMarketConclusion: "Conclusione del mercato più grande",
		biggestMarketConclusionHint: "È possibile fornire informazioni di conclusione sulla sezione dei mercati più grandi. Circa 150-250 caratteri con spazi.",
		biggestMarketConclusionPlaceholder: "Esempio: Valore della dimensione del mercato nel 2022 USD 285 milioni",
		keyMarketDrivers: "Principali driver di mercato",
		keyMarketDriversHint: "Fornire informazioni sui principali driver di mercato. Circa 400-600 caratteri con spazi.",
		keyMarketDriversPlaceholder: "Fornire informazioni sui principali driver di mercato.",
		marketOpportunities: "Opportunità di mercato",
		marketOpportunitiesHint: "Fornire informazioni sulle opportunità di mercato. Circa 400-600 caratteri con spazi.",
		marketOpportunitiesPlaceholder: "Fornire informazioni sulle opportunità di mercato.",
		clientNeeds: "Esigenze del cliente",
		clientNeedsHint: "Fornire informazioni sulle esigenze del cliente. Circa 400-600 caratteri con spazi.",
		clientNeedsPlaceholder: "Messaggio.",
		clientBenefits: "Benefici per il cliente",
		clientBenefitsHint: "Fornire informazioni sui benefici per il cliente. Circa 400-600 caratteri con spazi.",
		clientBenefitsPlaceholder: "Messaggio.",
		tips: "Suggerimenti",
		tipsHint: "Fornire informazioni sulle esigenze del cliente. Circa 600-800 caratteri con spazi.",
		tipsPlaceholder: "Messaggio.",
		keyHighlights: "Punti salienti",
		keyHighlightsHint: "Fornire informazioni sui punti salienti. Circa 400-600 caratteri con spazi.",
		keyHighlightsPlaceholder: "Fornire informazioni sui principali driver di mercato.",
		additionalNotes: "Note aggiuntive",
		additionalNotesHint: "Se necessario, aggiungere note aggiuntive per gli stakeholder che gestiranno la presentazione di questa offerta o della presentazione del settore. Circa 400-600 caratteri.",
		additionalNotesPlaceholder: "Fornire informazioni sui principali driver di mercato.",
		competitors: "Concorrenti",
		competitorsHint: "Seleziona i concorrenti di Akkodis sul mercato. Quando si aggiunge un nuovo concorrente che non è nelle opzioni fornite, il colore di sfondo di esso sarà giallo. Dopo l'approvazione, lo sfondo tornerà blu",
		competitorsPlaceholder: "Seleziona uno o più concorrenti.",
		addReference: "Aggiungi un riferimento",
		removeReference: "Rimuovi",
		references: "Riferimenti",
		referenceDescription: "Descrizione",
		referenceDescriptionHint: "Se necessario, fornire informazioni sul riferimento utilizzato.",
		referenceDescriptionPlaceholder: "Esempio: HFS Horizons: Generative Enterprise Services, 2023.",
		referenceUrl: "URL",
		referenceUrlHint: "Se necessario, fornire il riferimento utilizzato.",
		referenceUrlPlaceholder: "Esempio: https://www.hfsresearch.com/Generative-enterprise-2023",
		pleaseWait: "Attendere prego...",
		language: "Scegli la lingua",
		languageHint: "Quando invii in un'altra lingua, la tua offerta o presentazione del settore verrà automaticamente tradotta in inglese.",
		languagePlaceholder: "Scegli la lingua in cui desideri inviare la tua offerta o presentazione del settore",
		copyUrlSuccess: "L'URL è stato copiato correttamente.",
		akkodisAndIndustryPresentation: "Akkodis, Presentazioni del settore e delle pratiche",
		sectorPresentation: "Presentazione del settore",
		generalPresentation: "Presentazione generale",
		mainTechPractice: "Principale pratica tecnica",
		mainGlobalOwner: "Proprietario principale",
		mainGlobalOwnerPlaceholder: "Seleziona un proprietario principale",
		mainGlobalOwnerHint: "Puoi scegliere solo un proprietario principale",
		mainTechPracticeHint: "Puoi scegliere solo una pratica tecnica principale",
		mainTechPracticePlaceholder: "Seleziona una pratica tecnica",
		mainProjectIndustry: "Principale industria del progetto",
		mainProjectIndustryHint: "Puoi scegliere solo un'industria di progetto principale. Non disponibile per le presentazioni aziendali",
		mainProjectIndustryPlaceholder: "Seleziona un'industria di progetto",
		mobilePanoramicPhoto: 'Foto panoramica mobile',
		mobilePanoramicPhotoHint: "Risoluzione: 480x400px o 460x400px",
		doYouWantToProceedWithSubmit: "Vuoi procedere? Hai ancora campi vuoti.",
		emptyFields: "Campi vuoti",
		referenceStory: "Storia di riferimento",
		offerType: "Tipo di offerta",
		offerTypeLabel: "Seleziona il tipo",
		offerTypeHint: "Seleziona il tipo di offerta che stai inviando",
		offerTypePlaceholder: "Seleziona il tipo di offerta desiderato",
		globalOffer: "Offerta principale",
		globalOfferHint: "Seleziona l'offerta principale per questa offerta",
		globalOfferPlaceholder: "Seleziona il genitore dell'offerta localizzata",
		deliveryLocationDisabledHint: "Paese non disponibile, poiché esiste già un'offerta localizzata per quel paese",
		local: "Locale",
		global: "Globale",
		localized: "Localizzato",
		relatedOffersByContent: "Offerte correlate per contenuto",
		relatedSectorsByContent: "Settori correlati per contenuto",
		relatedPresentationsByContent: "Presentazioni correlate per contenuto",
		english: "Inglese",
		french: "Francese",
		german: "Tedesco",
		italian: "Italiano",
		japanese: "Giapponese",
		noTitle: "Nessun titolo",
		spanish: "Spagnolo",
		noRelatedOffers: "Nessuna offerta correlata",
		noRelatedSectors: "Nessuna presentazione del settore correlata",
		originalTranslation: "TRADUZIONE ORIGINALE",
		for: "per",
		addOffer: "Aggiungi un'offerta",
		removeOffer: "Rimuovi",
		offerReferences: "Offerte correlate",
		offerLabel: "Offerta",
		offerPlaceholder: "Seleziona un'offerta correlata",
		offerLabelEn: "Offerte in inglese",
		offerHintEn: "Seleziona una o più offerte correlate in inglese",
		offerPlaceholderEn: "Seleziona una o più offerte correlate in inglese",
		offerLabelFr: "Offerte in francese",
		offerHintFr: "Seleziona una o più offerte correlate in francese",
		offerPlaceholderFr: "Seleziona una o più offerte correlate in francese",
		offerLabelDe: "Offerte in tedesco",
		offerHintDe: "Seleziona una o più offerte correlate in tedesco",
		offerPlaceholderDe: "Seleziona una o più offerte correlate in tedesco",
		offerLabelIt: "Offerte in italiano",
		offerHintIt: "Seleziona una o più offerte correlate in italiano",
		offerPlaceholderIt: "Seleziona una o più offerte correlate in italiano",
		offerLabelJa: "Offerte in giapponese",
		offerHintJa: "Seleziona una o più offerte correlate in giapponese",
		offerPlaceholderJa: "Seleziona una o più offerte correlate in giapponese",
		offerLabelEs: "Offerte in spagnolo",
		offerHintEs: "Seleziona una o più offerte correlate in spagnolo",
		offerPlaceholderEs: "Seleziona una o più offerte correlate in spagnolo",
		sectorType: "Tipo di presentazione",
		sectorTypeLabel: "Seleziona il tipo",
		sectorTypeHint: "Seleziona il tipo di presentazione che stai inviando",
		sectorTypePlaceholder: "Seleziona il tipo di presentazione desiderata",
		globalSectors: "Settore principale",
		globalSectorHint: "Seleziona il genitore per questa presentazione del settore",
		globalSectorPlaceholder: "Seleziona il genitore della presentazione localizzata",
		sectorReferences: "Presentazioni correlate",
		sectorLabelEn: "Presentazioni in inglese",
		sectorHintEn: "Seleziona una o più presentazioni correlate in inglese",
		sectorPlaceholderEn: "Seleziona una o più presentazioni correlate in inglese",
		sectorLabelFr: "Presentazioni in francese",
		sectorHintFr: "Seleziona una o più presentazioni correlate in francese",
		sectorPlaceholderFr: "Seleziona una o più presentazioni correlate in francese",
		sectorLabelDe: "Presentazioni in tedesco",
		sectorHintDe: "Seleziona una o più presentazioni correlate in tedesco",
		sectorPlaceholderDe: "Seleziona una o più presentazioni correlate in tedesco",
		sectorLabelIt: "Presentazioni in italiano",
		sectorHintIt: "Seleziona una o più presentazioni correlate in italiano",
		sectorPlaceholderIt: "Seleziona una o più presentazioni correlate in italiano",
		sectorLabelJa: "Presentazioni in giapponese",
		sectorHintJa: "Seleziona una o più presentazioni correlate in giapponese",
		sectorPlaceholderJa: "Seleziona una o più presentazioni correlate in giapponese",
		sectorLabelEs: "Presentazioni in spagnolo",
		sectorHintEs: "Seleziona una o più presentazioni correlate in spagnolo",
		sectorPlaceholderEs: "Seleziona una o più presentazioni correlate in spagnolo",
		resources: "Risorse",
		resourcesHint: "Puoi scegliere più di una risorsa per questa presentazione dell’offerta o del settore",
		resourcesPlaceholder: "Seleziona una o più risorse",
		link: "Collegamento",
		links: "Collegamenti",
		addLink: "Aggiungi un collegamento",
		removeLink: "Rimuovi",
		linkNameHint: "Nome del collegamento utilizzato.",
		linkUrlHint: "Se necessario, fornire il collegamento utilizzato.",
		linkName: "Nome",
		linkUrl: "URL",
		hintNamePlaceholder: "Esempio: Notizie di mercato rilevanti",
		hintUrlPlaceholder: "Esempio: https://www.relevantnews.com",
		cannotAddMore: "Impossibile aggiungere altro",
		demandGenerationResources: "Risorse di generazione della domanda",
		doYouWantToPreloadGlobalOfferData: "Vuoi precaricare i dati dell'offerta globale nel modulo?",
		doYouWantToPreloadGlobalSectorData: "Vuoi precaricare i dati della presentazione del settore globale nel modulo?",
		isCorporatePresentation: "Presentazione aziendale",
		recognitionsHint: "Puoi aggiungere riconoscimenti relativi a questa presentazione dell’offerta o del settore, come premi, riconoscimenti degli analisti, ecc.",
		recognitionsPlaceholder: "Seleziona uno o più riconoscimenti",
		recognitions: 'Riconoscimenti di Akkodis',
		uploadLogo: 'Carica il logo',
		uploadResource: 'Carica la risorsa',
		recognitionDescription: 'Esempio: Servizi ER&D e ingegneria digitale',
		recognitionLinkHint: 'Il collegamento al riconoscimento può essere aggiunto se nessuna risorsa è caricata. Se si desidera aggiungere un collegamento, rimuovere la risorsa.',
		recognitionsWarning: 'Si prega di notare che un riconoscimento incompleto non verrà salvato.',
		recognitionsWarningHint: "Un riconoscimento incompleto è un riconoscimento senza descrizione, senza logo o senza collegamento o file.",
		addEditor: "Aggiungi un editore",
		removeEditor: "Rimuovi",
		editors: "Editori",
		editorsHint: "Concedi a una persona il diritto di modificare, salvare e inviare.",
		editorPlaceholder: "Seleziona uno o più editori",
		editorsSubTitle: "Editore",
		footer: {
			contactUs: 'Contattaci',
			reportProblem: "Segnala un problema",
			resources: "Risorse",
			contactCMT: 'Contatta CMT'
		},
		confirmationRequired: 'Conferma richiesta',
		projects: "Progetti",
		publishedProjects: 'Progetti pubblicati',
		revenues: "Entrate",
		drafts: "Bozze",
		archived: "Archiviato",
		shared: "Condiviso",
		forReview: "Per revisione",
		surveyQuestions: "Domande del sondaggio",
		needHelp: 'Hai bisogno di aiuto? Clicca qui.',
		surveyName: "Nome del sondaggio",
		question: "Domanda",
		deleteQuestion: "Elimina domanda",
		addQuestion: "Aggiungi domanda",
		type: 'Tipo',
		enterQuestionText: "Inserisci il testo della domanda",
		answerText: "Testo della risposta",
		deleteAnswer: "Elimina risposta",
		answers: "Risposte",
		singleChoice: "Scelta singola",
		multipleChoice: "Scelta multipla",
		textResponse: "Risposta testuale",
		addAnswer: "Aggiungi risposta",
		createSurvey: "Crea un sondaggio",
		areYouSureYouWantToDeleteSurvey: "Sei sicuro di voler eliminare il sondaggio?",
		saveSurvey: "Salva sondaggio",
		surveySaveSuccess: "Sondaggio salvato con successo.",
		surveyGetFailed: "Si è verificato un problema durante il recupero del sondaggio. Riprova. Se il problema persiste, contatta il team CMT.",
		surveyNotValid: "Il sondaggio non è valido. Controlla le domande e le risposte.",
		errorSavingSurvey: "Errore durante il salvataggio del sondaggio. Riprova. Se il problema persiste, contatta il team CMT.",
		delete: "Elimina",
		active: "Attivo",
		setActive: "Imposta come attivo",
		activate: 'Attiva',
		deactivate: 'Disattiva',
		createVideo: "Crea un video",
		wrongTypePleaseUploadVideo: "Tipo di file errato! Carica un file video.",
		hide: 'Nascondi',
		show: 'Mostra',
		deleteVideoMessage: "Sei sicuro di voler eliminare questo video?",
		videoDeletedSuccessfully: "Video eliminato con successo.",
		successfullySavedVideo: "Video salvato con successo.",
		wrongId: "L'elemento non esiste. Controlla l'URL.",
		fillAllFields: "Compila tutti i campi.",
		currentVideo: "Video attuale",
		videoTitle: "Titolo del video",
		videoDescription: "Descrizione del video",
		confirmVideoTranslations: "Il salvataggio sovrascriverà le traduzioni esistenti e applicherà traduzioni automatiche dall'inglese. Sei sicuro di voler continuare?",
		successfullyCreatedVideo: "Video creato con successo.",
		errorWhileSaving: "Errore durante il salvataggio. Riprova. Se il problema persiste, contatta il team CMT.",
		deleteResourceFileMessage: "Sei sicuro di voler eliminare questo file di risorse?",
		resourceFileDeletedSuccessfully: "File di risorse eliminato con successo.",
		successfullySavedResourceFile: "File di risorse salvato con successo.",
		currentResourceFile: "File di risorse attuale",
		resourceFileTitle: "Titolo del file di risorse",
		resourceFileDescription: "Descrizione del file di risorse",
		confirmResourceFileTranslations: "Il salvataggio sovrascriverà le traduzioni esistenti e applicherà traduzioni automatiche dall'inglese. Sei sicuro di voler continuare?",
		successfullyCreatedResourceFile: "File di risorse creato con successo.",
		createResourceFile: "Crea un file di risorse",
		wrongTypePleaseUploadResourceFile: "Tipo di file errato! Carica un file di risorse.",
		downloadCurrentFile: "Scarica il file attuale",
		createPromotion: "Crea una promozione",
		deletePromotionMessage: "Sei sicuro di voler eliminare questa promozione?",
		promotionDeletedSuccessfully: "Promozione eliminata con successo.",
		pleaseSelectProject: "Seleziona un progetto.",
		promotionCreatedSuccessfully: "Promozione creata con successo.",
		increase: "Aumenta",
		decrease: "Diminuisci",
		promotedUntil: "Promosso fino a",
		selectAProjectForPromotion: "Seleziona un progetto per la promozione",
		promote: "Promuovi",
		categoryLabel: "Categoria",
		categoryPlaceholder: "Seleziona una categoria",
		categoryHint: "Seleziona una categoria per questa presentazione",
		doYouWantToSendEmailForNextPublishing: "Vuoi inviare un'email al proprietario quando il progetto verrà pubblicato la prossima volta?",
		emailDisabledOnPublish: "Nessuna email verrà inviata al proprietario quando il progetto verrà pubblicato la prossima volta.",
		sendEmail: "Inviare un'email?",
		annualRevenue: "Reddito annuo",
		annualRevenueHint: "Inserisci il reddito annuo generato da questo progetto",
		annualRevenuePlaceholder: "Inserisci il reddito annuo",
		maturity: "Maturità",
		maturityHint: "Seleziona il livello di maturità di questo progetto",
		maturityPlaceholder: "Seleziona il livello di maturità",
		confirmAndClose: "Conferma e chiudi",
		startTour: "Inizia il tour",
		welcome: "Benvenuto!",
		welcomeText: "La nuova versione di GOP è ora disponibile. Seleziona il tuo paese per personalizzare la tua esperienza. Puoi iniziare un breve tour per scoprire le novità o semplicemente confermare e chiudere.",
		country: "Paese",
		countryPlaceholder: "Seleziona",
		countryError: "Seleziona un paese per continuare.",
		recognition: "Riconoscimento",
		titlePlaceholder: "Inserisci il titolo qui",
		file: 'File',
		fileHint: 'Carica un file',
		logo: "Logo",
		logoHint: "Carica un logo",
		url: "URL",
		urlPlaceholder: "Inserisci un URL",
		region: "Regione",
		regionPlaceholder: "Seleziona una regione",
		infoDatePlaceHolder: 'Seleziona l\'anno specifico relativo a questo riconoscimento',
		badge: "Badge",
		analysts: "Analisti",
		analystsPlaceholder: "Seleziona gli analisti",
		additionalLinks: "Link aggiuntivi",
		insights: "Approfondimenti",
		insightsPlaceholder: "Fornisci approfondimenti relativi a questo riconoscimento, come perché è stato assegnato, cosa significa per Akkodis, ecc.",
		relatedPartnershipPresentations: "Presentazioni di partnership correlate",
		relatedPartnershipPresentationsPlaceholder: "Seleziona una o più presentazioni di partnership correlate",
		relatedSectors: "Presentazioni di settore correlate",
		relatedSectorsPlaceholder: "Seleziona una o più presentazioni di settore correlate",
		relatedSectorsHint: "Seleziona una o più presentazioni di settore correlate a questa presentazione dell’offerta o del settore",
		relatedOffers: "Offerte correlate",
		relatedOffersPlaceholder: "Seleziona una o più offerte correlate",
		relatedOffersHint: "Seleziona una o più offerte correlate a questa presentazione dell’offerta o del settore",
		images: "Immagini",
		logoAndBadge: "Logo e badge",
		relatedAndImages: "Correlati e immagini",
		recognitionFileLabel: "File",
		recognitionFileHint: "Carica un file. Puoi compilare un URL o caricare un file. Il caricamento di un file sovrascriverà l'URL con l'URL del file caricato",
		addCountrySectorItems: "Aggiungi elemento",
		removeCountrySectorItems: "Rimuovi elemento",
		countrySectorItems: "Elementi paese e settore",
		countrySectorItemResultHint: "Numero di elementi paese e settore da visualizzare accanto all'immagine del paese nella pagina di presentazione del paese",
		countrySectorItemTextHint: "Testo da visualizzare accanto all'immagine del paese nella pagina di presentazione del paese",
		countryImage: "Immagine del paese",
		countryImageHint: "Carica un'immagine del paese da visualizzare nella pagina di presentazione del paese accanto agli elementi paese",
		recognitionGalleryUploadGroupHint: "Carica una galleria per i riconoscimenti. Puoi caricare immagini relative al riconoscimento, come foto della cerimonia di premiazione, immagini del premio stesso, ecc.",
		videoLinks: "Collegamenti video",
		videoHintNamePlaceholder: "Inserisci il nome del collegamento video",
		videoHintUrlPlaceholder: "Inserisci l'URL del collegamento video",
		countries: "Paesi",
		infoDate: "Data di riferimento",
		marketData: 'Dati di mercato'
	},
	[LANGUAGE.ja.short]: {
		areYouSure: "本気ですか？",
		confirmAction: "アクションの確認",
		areYouSureYouWantToUnpublish: "公開を取り消してもよろしいですか",
		areYouSureYouWantToArchive: "アーカイブしてもよろしいですか",
		areYouSureYouWantToReturnProjectToDraft: "プロジェクトを RO に戻してもよろしいですか?",
		areYouSureYouWantToRejectProject: "プロジェクトを拒否してもよろしいですか?",
		areYouSureYouWantToDeleteProject: "プロジェクトを削除してもよろしいですか?",
		areYouSureYouWantToUnarchiveProject: "プロジェクトを復元してもよろしいですか?",
		areYouSureYouWantToArchiveProject: "プロジェクトをアーカイブしてもよろしいですか?",
		theProject: "プロジェクト",
		yes: 'はい',
		no: "いいえ",
		ok: 'わかりました',
		websiteUnderMaintenance: "ウェブサイトはメンテナンス中です",
		weAreImprovingWebsite: "私たちはウェブサイトを改善しています。 すぐに戻ります",
		startYear: "開始年",
		startMonth: "開始月",
		endYear: "終了年",
		endMonth: "終了月",
		year: "年",
		month: "月",
		day: "日",
		denying: "否定",
		deny: "拒否する",
		cancel: "キャンセル",
		approving: "承認",
		approve: "承認する",
		save: "保存",
		preview: "プレビュー",
		edit: "編集",
		loading: "読み込み中",
		yourSessionHasExpired: "セッションが期限切れになりました",
		pleaseLoginAgain: "次の時間以降に再度ログインしてください:",
		youWillBeLoggedOutIn: "ログアウトします。",
		backToRO: "参照所有者に戻る",
		rejectButton: "拒否する",
		reasons: "返品理由を下記にご記入ください。",
		reasonsForRejecting: "以下に拒否理由をご記入ください。",
		writeHere: "ここにテキストを書きます",
		commonPopupPlaceholder: "ここにテキストを書いてください",
		commonPopupError: "テキストフィールドは必須です。",
		name: "名",
		intro: "紹介",
		offerPresentation: "オファーのプレゼンテーション",
		presentationAndVideoLink: "プレゼンテーションとビデオリンク",
		globalOwners: "オーナー",
		akkodisExpertise: "Akkodis の専門知識",
		marketInsights: "市場の洞察",
		clientNeedsAndBenefits: "顧客のニーズとメリット",
		tipsAndTricks: "ヒントとトリック",
		referencesAndSuccessStories: "参考文献と成功事例",
		actions: 'アクション',
		validate: '確認',
		backToTop: 'トップに戻る',
		submit: '提出する',
		presentationType: 'セクターまたはオファープレゼンテーション',
		presentationTypeSector: 'セクター',
		presentationTypeOffer: 'オファー',
		title: 'タイトル',
		presentationTitleHere: 'ここにプレゼンテーションタイトル',
		thumbnail: 'サムネイル',
		thumbnailHint: "解像度：300x200px 以上。 比率：長方形 3:2",
		panoramicPhoto: 'パノラマ写真',
		panoramicPhotoHint: "解像度: 1920x535px または 1200x338px。",
		description: '説明',
		descriptionPlaceholder: 'オファーまたはセクタープレゼンテーションの背景情報を提供してください。 その理由と文脈、顧客への付加価値。',
		descriptionHint: "オファーまたはセクタープレゼンテーションの背景情報を提供してください。 その理由と文脈、顧客への付加価値。 空白を含む約600〜800文字。",
		deliveryLocation: '配送先',
		deliveryLocationPlaceholder: "1つ以上の国を選択してください",
		singleDeliveryLocationPlaceholder: "1つの国を選択してください",
		deliveryLocationHint: "オファーに関連する活動を実施できるすべての国をリストアップします",
		length: "長さ",
		ftes: "FTE",
		ftesHint: "このアクティビティに関与する Akkodis の従業員数を入力してください",
		presentationPPT: "プレゼンテーションバージョン PPT",
		presentationPPTHint: "プレゼンテーションの PPT バージョンをアップロードします（英語のみ）",
		presentationPDF: "プレゼンテーションバージョン PDF",
		presentationPDFHint: "プレゼンテーションの PDF バージョンをアップロードします（英語のみ）",
		email: "メール",
		globalOwnersNameHint: 'グローバルオーナーは GOP 内でのみ表示されます。 外部ドキュメントでは表示されません。',
		globalOwnersEmailHint: 'グローバルオーナーは GOP 内でのみ表示されます。 外部ドキュメントでは表示されません。',
		globalOwnersNamePlaceholder: "例：John Silverman",
		globalOwnersEmailPlaceholder: "例：JohnSilverman@akkodis.com",
		globalOwnersSubTitle: "オーナー",
		addItem: "アイテムを追加",
		removeItem: "アイテムを削除",
		addGlobalOwner: "オーナーを追加",
		removeGlobalOwner: "オーナーを削除",
		videoLink: "ビデオリンク",
		videoLinkHint: "セクターまたはオファープレゼンテーションに関連する外部リンクをビデオに共有できます",
		videoLinkPlaceholder: "ビデオの URL...",
		projectIndustry: "プロジェクト業界",
		projectIndustryHint: "このオファーまたはセクタープレゼンテーションについて、1つの業界のみを選択できます",
		serviceLines: "事業の種類",
		serviceLinesHint: "このオファーまたはセクタープレゼンテーションでは、複数の事業の種類を選択できます。",
		techPractices: "テックプラクティス",
		techPracticesHint: "このオファーまたはセクタープレゼンテーションに複数のテックプラクティスを選択できます",
		mainClientPersona: "メインクライアントペルソナ",
		mainClientPersonaHint: "このオファーまたはセクタープレゼンテーションに複数のメインクライアントペルソナを選択できます",
		mainClientPersonaPlaceholder: "1つ以上のドメインを選択",
		lifecycle: "ライフサイクル",
		lifecycleHint: "このオファーまたはセクタープレゼンテーションに複数のライフサイクルを選択できます",
		lifecyclePlaceholder: "1つ以上のライフサイクルパートを選択",
		toolsAndSystems: "ツールとシステム",
		toolsAndSystemsHint: "チームが使用するハードウェアとソフトウェア、使用されているテクノロジー。 提供されたオプションにない新しいツールを追加すると、その背景色が黄色になります。 承認後、背景色が青に戻ります",
		toolsAndSystemsPlaceholder: "1つ以上のツールとシステムを選択",
		certifications: "認証",
		certificationsHint: "使用される標準、方法論、フレームワーク。 提供されたオプションにない新しい認証を追加すると、その背景色が黄色になります。 承認後、背景色が青に戻ります",
		certificationsPlaceholder: "1つ以上の認証を選択",
		largestMarket: "最大市場",
		largestMarketHint: "最大市場の国を選択してください",
		largestMarketPlaceholder: "1つ以上の国を選択",
		fastestGrowingMarket: "最も成長している市場",
		fastestGrowingMarketHint: "最も成長している市場の国を選択してください",
		fastestGrowingMarketPlaceholder: "1つ以上の国を選択",
		biggestMarketConclusion: "最大市場の結論",
		biggestMarketConclusionHint: "最大市場セクションに関する結論情報を提供できます。 約150〜250文字。",
		biggestMarketConclusionPlaceholder: "例：2022 年の市場規模は 285 百万ドル",
		keyMarketDrivers: "主要市場ドライバー",
		keyMarketDriversHint: "主要市場ドライバーに関する情報を提供してください。 約400〜600文字。",
		keyMarketDriversPlaceholder: "主要市場ドライバーに関する情報を提供してください。",
		marketOpportunities: "市場の機会",
		marketOpportunitiesHint: "市場の機会に関する情報を提供してください。 約400〜600文字。",
		marketOpportunitiesPlaceholder: "市場の機会に関する情報を提供してください。",
		clientNeeds: "顧客ニーズ",
		clientNeedsHint: "顧客ニーズに関する情報を提供してください。 約400〜600文字。",
		clientNeedsPlaceholder: "メッセージ。",
		clientBenefits: "顧客の利点",
		clientBenefitsHint: "顧客の利点に関する情報を提供してください。 約400〜600文字。",
		clientBenefitsPlaceholder: "メッセージ。",
		tips: "ヒント",
		tipsHint: "顧客ニーズに関する情報を提供してください。 約600〜800文字。",
		tipsPlaceholder: "メッセージ。",
		keyHighlights: "キーハイライト",
		keyHighlightsHint: "キーハイライトに関する情報を提供してください。 約400〜600文字。",
		keyHighlightsPlaceholder: "主要市場ドライバーに関する情報を提供してください。",
		additionalNotes: "追加のメモ",
		additionalNotesHint: "必要に応じて、このオファーまたはセクタープレゼンテーションのプレゼンテーションをサポートするステークホルダーに追加のメモを追加します。 約400〜600文字。",
		additionalNotesPlaceholder: "主要市場ドライバーに関する情報を提供してください。",
		competitors: "競合他社",
		competitorsHint: "市場での Akkodis の競合他社を選択します。 提供されたオプションにない新しい競合他社を追加すると、その背景色が黄色になります。 承認後、背景色が青に戻ります",
		competitorsPlaceholder: "1つ以上の競合他社を選択",
		addReference: "参照を追加",
		removeReference: "削除",
		references: "参照",
		referenceDescription: "説明",
		referenceDescriptionHint: "必要に応じて使用される参照に関する情報を提供します。",
		referenceDescriptionPlaceholder: "例：HFS Horizons: Generative Enterprise Services, 2023.",
		referenceUrl: "URL",
		referenceUrlHint: "必要に応じて使用される参照を提供します。",
		referenceUrlPlaceholder: "例：https://www.hfsresearch.com/Generative-enterprise-2023",
		pleaseWait: "お待ちください...",
		language: "言語を選択",
		languageHint: "別の言語で提出すると、オファーまたはセクタープレゼンテーションが自動的に英語に翻訳されます。",
		languagePlaceholder: "提出する言語を選択してください",
		copyUrlSuccess: "URL は正常にコピーされました。",
		akkodisAndIndustryPresentation: "Akkodis、業界およびプラクティスのプレゼンテーション",
		sectorPresentation: "業界プレゼンテーション",
		generalPresentation: "一般的なプレゼンテーション",
		mainTechPractice: "主要技術プラクティス",
		mainGlobalOwner: "メインオーナー",
		mainGlobalOwnerPlaceholder: "メインオーナーを1人選択",
		mainGlobalOwnerHint: "メインオーナーは1人しか選択できません",
		mainTechPracticeHint: "主要技術プラクティスは 1 つだけ選択できます",
		mainTechPracticePlaceholder: "技術プラクティスを選択",
		mainProjectIndustry: "主要プロジェクト業界",
		mainProjectIndustryHint: "主要プロジェクト業界は 1 つだけ選択できます。 企業プレゼンテーションには適用されません",
		mainProjectIndustryPlaceholder: "プロジェクト業界を選択",
		mobilePanoramicPhoto: 'モバイルパノラマ写真',
		mobilePanoramicPhotoHint: "解像度：480x400px または 460x400px",
		doYouWantToProceedWithSubmit: "続行しますか？ まだ空のフィールドがあります。",
		emptyFields: "空のフィールド",
		referenceStory: "参照ストーリー",
		offerType: "オファータイプ",
		offerTypeLabel: "タイプを選択",
		offerTypeHint: "提出するオファータイプを選択してください",
		offerTypePlaceholder: "ご希望のオファーの種類を選択してください",
		globalOffer: "親オファー",
		globalOfferHint: "このオファーの親を選択してください",
		globalOfferPlaceholder: "ローカライズされた親を選択してください",
		deliveryLocationDisabledHint: "この国に関するローカライズされたオファーが存在するため、利用できません",
		local: "地元",
		global: "グローバル",
		localized: "ローカライズ",
		relatedOffersByContent: "コンテンツによる関連オファー",
		relatedSectorsByContent: "コンテンツによる関連セクター",
		relatedPresentationsByContent: "コンテンツによる関連プレゼンテーション",
		english: "英語",
		french: "フランス語",
		german: "ドイツ語",
		italian: "イタリア語",
		japanese: "日本語",
		spanish: "スペイン語",
		noTitle: "タイトルなし",
		noRelatedOffers: "関連するオファーはありません",
		noRelatedSectors: "関連するセクタープレゼンテーションはありません",
		originalTranslation: "オリジナル翻訳",
		for: "に",
		addOffer: "オファーを追加",
		removeOffer: "削除",
		offerReferences: "関連オファー",
		offerLabel: "オファー",
		offerPlaceholder: "関連オファーを選択してください",
		offerLabelEn: "英語のオファー",
		offerHintEn: "英語の関連オファーを複数選択してください",
		offerPlaceholderEn: "英語の関連オファーを複数選択してください",
		offerLabelFr: "フランス語のオファー",
		offerHintFr: "フランス語の関連オファーを複数選択してください",
		offerPlaceholderFr: "フランス語の関連オファーを複数選択してください",
		offerLabelDe: "ドイツ語のオファー",
		offerHintDe: "ドイツ語の関連オファーを複数選択してください",
		offerPlaceholderDe: "ドイツ語の関連オファーを複数選択してください",
		offerLabelIt: "イタリア語のオファー",
		offerHintIt: "イタリア語の関連オファーを複数選択してください",
		offerPlaceholderIt: "イタリア語の関連オファーを複数選択してください",
		offerLabelJa: "日本語のオファー",
		offerHintJa: "日本語の関連オファーを複数選択してください",
		offerPlaceholderJa: "日本語の関連オファーを複数選択してください",
		offerLabelEs: "スペイン語のオファー",
		offerHintEs: "スペイン語の関連オファーを複数選択してください",
		offerPlaceholderEs: "スペイン語の関連オファーを複数選択してください",
		sectorType: "プレゼンテーションの種類",
		sectorTypeLabel: "タイプを選択",
		sectorTypeHint: "提出するプレゼンテーションの種類を選択してください",
		sectorTypePlaceholder: "提出するプレゼンテーションの種類を選択してください",
		globalSectors: "親セクタープレゼンテーション",
		globalSectorHint: "このプレゼンテーションの親を選択してください",
		globalSectorPlaceholder: "ローカライズされた親を選択してください",
		sectorReferences: "関連プレゼンテーション",
		sectorLabelEn: "英語でのプレゼンテーション",
		sectorHintEn: "関連する英語のプレゼンテーションを1つ以上選択してください",
		sectorPlaceholderEn: "関連する英語のプレゼンテーションを1つ以上選択してください",
		sectorLabelFr: "フランス語でのプレゼンテーション",
		sectorHintFr: "関連するフランス語のプレゼンテーションを1つ以上選択してください",
		sectorPlaceholderFr: "関連するフランス語のプレゼンテーションを1つ以上選択してください",
		sectorLabelDe: "ドイツ語でのプレゼンテーション",
		sectorHintDe: "関連するドイツ語のプレゼンテーションを1つ以上選択してください",
		sectorPlaceholderDe: "関連するドイツ語のプレゼンテーションを1つ以上選択してください",
		sectorLabelIt: "イタリア語でのプレゼンテーション",
		sectorHintIt: "関連するイタリア語のプレゼンテーションを1つ以上選択してください",
		sectorPlaceholderIt: "関連するイタリア語のプレゼンテーションを1つ以上選択してください",
		sectorLabelJa: "日本語でのプレゼンテーション",
		sectorHintJa: "関連する日本語のプレゼンテーションを1つ以上選択してください",
		sectorPlaceholderJa: "関連する日本語のプレゼンテーションを1つ以上選択してください",
		sectorLabelEs: "スペイン語でのプレゼンテーション",
		sectorHintEs: "関連するスペイン語のプレゼンテーションを1つ以上選択してください",
		sectorPlaceholderEs: "関連するスペイン語のプレゼンテーションを1つ以上選択してください",
		resources: "リソース",
		resourcesHint: "このオファーまたはセクタープレゼンテーションに複数のリソースを選択できます",
		resourcesPlaceholder: "1つ以上のリソースを選択",
		link: "リンク",
		links: "リンク",
		addLink: "リンクを追加",
		removeLink: "削除",
		linkNameHint: "使用されるリンクの名前。",
		linkUrlHint: "必要に応じて使用されるリンクを提供します。",
		linkName: "名",
		linkUrl: "URL",
		hintNamePlaceholder: "例：関連ニュース",
		hintUrlPlaceholder: "例：https://www.relevantnews.com",
		cannotAddMore: "追加できません",
		demandGenerationResources: "需要創出リソース",
		doYouWantToPreloadGlobalOfferData: "グローバルオファーデータを事前読み込みしますか？",
		doYouWantToPreloadGlobalSectorData: "グローバルセクターデータを事前読み込みしますか？",
		isCorporatePresentation: "企業プレゼンテーション",
		recognitions: 'Akkodis の表彰',
		recognitionsHint: "このオファーまたはセクタープレゼンテーションに関連する表彰を追加できます。 例：賞、アナリストの認識など。",
		recognitionsPlaceholder: "1つ以上の表彰を選択",
		uploadLogo: 'ロゴをアップロード',
		uploadResource: 'リソースをアップロード',
		recognitionDescription: '例：ER&D サービスとデジタルエンジニアリング',
		recognitionLinkHint: 'リソースがアップロードされていない場合、認識へのリンクを追加できます。 リンクを追加する場合は、リソースを削除してください。',
		recognitionsWarning: '不完全な認識は保存されません。',
		recognitionsWarningHint: "不完全な認識とは、説明、ロゴ、リンクまたはファイルのない認識です。",
		addEditor: "エディターを追加",
		removeEditor: "削除",
		editors: "エディター",
		editorsHint: "人に編集、保存、送信の権限を付与します。",
		editorPlaceholder: "1つ以上のエディターを選択",
		editorsSubTitle: "エディター",
		footer: {
			contactUs: 'お問い合わせ',
			reportProblem: "問題を報告する",
			resources: "リソース",
			contactCMT: 'CMTにお問い合わせください'
		},
		confirmationRequired: '確認が必要です',
		projects: "プロジェクト",
		publishedProjects: '公開プロジェクト',
		revenues: "収益",
		drafts: "ドラフト",
		archived: "アーカイブ済み",
		shared: "共有",
		forReview: "レビュー用",
		surveyQuestions: "調査質問",
		needHelp: 'ヘルプが必要ですか? ここをクリックしてください。',
		surveyName: "調査名",
		question: "質問",
		deleteQuestion: "質問を削除",
		addQuestion: "質問を追加",
		type: "タイプ",
		enterQuestionText: "質問テキストを入力",
		answerText: "回答テキスト",
		deleteAnswer: "回答を削除",
		answers: "回答",
		singleChoice: "単一選択",
		multipleChoice: "複数選択",
		textResponse: "テキスト応答",
		addAnswer: "回答を追加",
		createSurvey: "調査を作成",
		areYouSureYouWantToDeleteSurvey: "調査を削除してもよろしいですか?",
		saveSurvey: "調査を保存",
		surveySaveSuccess: "調査が正常に保存されました。",
		surveyGetFailed: "調査の取得に失敗しました。後でもう一度お試しください。",
		surveyNotValid: "調査は無効です。質問と回答を確認してください。",
		errorSavingSurvey: "調査の保存中にエラーが発生しました。後でもう一度お試しください。",
		delete: "削除",
		active: "アクティブ",
		setActive: "アクティブに設定",
		activate: "アクティブ化",
		deactivate: "非アクティブ化",
		createVideo: "ビデオを作成",
		wrongTypePleaseUploadVideo: "ビデオをアップロードしてください。正しいタイプではありません。",
		hide: "非表示",
		show: "表示",
		deleteVideoMessage: "ビデオを削除してもよろしいですか？",
		videoDeletedSuccessfully: "ビデオが正常に削除されました。",
		successfullySavedVideo: "ビデオが正常に保存されました。",
		wrongId: "ビデオ IDが正しくありません。",
		fillAllFields: "すべてのフィールドに入力してください。",
		currentVideo: "現在のビデオ",
		videoTitle: "ビデオタイトル",
		videoDescription: "ビデオの説明",
		confirmVideoTranslations: "ビデオ翻訳を確認",
		successfullyCreatedVideo: "ビデオが正常に作成されました。",
		errorWhileSaving: "保存中にエラーが発生しました。後でもう一度お試しください。",
		deleteResourceFileMessage: "リソースファイルを削除してもよろしいですか？",
		resourceFileDeletedSuccessfully: "リソースファイルが正常に削除されました。",
		successfullySavedResourceFile: "リソースファイルが正常に保存されました。",
		currentResourceFile: "現在のリソースファイル",
		resourceFileTitle: "リソースファイルタイトル",
		resourceFileDescription: "リソースファイルの説明",
		confirmResourceFileTranslations: "リソースファイル翻訳を確認",
		successfullyCreatedResourceFile: "リソースファイルが正常に作成されました。",
		createResourceFile: "リソースファイルを作成",
		wrongTypePleaseUploadResourceFile: "リソースファイルをアップロードしてください。正しいタイプではありません。",
		downloadCurrentFile: "現在のファイルをダウンロード",
		createPromotion: "プロモーションを作成",
		deletePromotionMessage: "プロモーションを削除してもよろしいですか？",
		promotionDeletedSuccessfully: "プロモーションが正常に削除されました。",
		pleaseSelectProject: "プロジェクトを選択してください。",
		promotionCreatedSuccessfully: "プロモーションが正常に作成されました。",
		increase: "増加",
		decrease: "減少",
		promotedUntil: "まで昇格",
		selectAProjectForPromotion: "プロモーションのプロジェクトを選択してください",
		promote: "昇格",
		categoryLabel: "カテゴリー",
		categoryHint: "提出するカテゴリーを選択してください",
		categoryPlaceholder: "希望するカテゴリーを選択してください",
		doYouWantToSendEmailForNextPublishing: "次の公開のためにメールを送信しますか？",
		emailDisabledOnPublish: "公開時にメールは無効です。",
		sendEmail: "メールを送信",
		annualRevenue: "年間収益",
		annualRevenueHint: "このプロジェクトから得られる年間収益を入力してください",
		annualRevenuePlaceholder: "年間収益を入力してください",
		maturity: "成熟度",
		maturityHint: "このプロジェクトの成熟度レベルを選択してください",
		maturityPlaceholder: "このプロジェクトの成熟度レベルを選択してください",
		confirmAndClose: "確認して閉じる",
		startTour: "ツアーを開始",
		welcome: "ようこそ！",
		welcomeText: "GOPの新しいバージョンが利用可能になりました。国を選択して、エクスペリエンスをパーソナライズしてください。新機能を確認するための短いツアーを開始するか、単に確認して閉じることができます。",
		country: "国",
		countryPlaceholder: "選択してください",
		countryError: "続行するには国を選択してください。",
		recognition: "認識",
		titlePlaceholder: "ここにタイトルを入力",
		file: 'ファイル',
		fileHint: 'ファイルをアップロード',
		logo: "ロゴ",
		logoHint: "ロゴをアップロード",
		url: "URL",
		urlPlaceholder: "ここにURLを入力",
		region: "地域",
		regionPlaceholder: "選択してください",
		infoDatePlaceHolder: 'この表彰に関連する特定の年を選択してください',
		badge: "バッジ",
		analysts: "アナリスト",
		analystsPlaceholder: "関連するアナリストを選択してください",
		additionalLinks: "追加のリンク",
		insights: "洞察",
		insightsPlaceholder: "関連する洞察を選択してください",
		relatedPartnershipPresentations: "関連するパートナーシッププレゼンテーション",
		relatedPartnershipPresentationsPlaceholder: "1つ以上の関連するパートナーシッププレゼンテーションを選択してください",
		relatedSectors: "関連するセクタープレゼンテーション",
		relatedSectorsPlaceholder: "1つ以上の関連するセクタープレゼンテーションを選択してください",
		relatedSectorsHint: "関連するセクタープレゼンテーションを選択してください。 これにより、オファーまたはセクタープレゼンテーションのコンテンツが強化されます。",
		relatedOffers: "関連するオファー",
		relatedOffersPlaceholder: "1つ以上の関連するオファーを選択してください",
		relatedOffersHint: "関連するオファーを選択してください。 これにより、オファーまたはセクタープレゼンテーションのコンテンツが強化されます。",
		images: "画像",
		logoAndBadge: "ロゴとバッジ",
		relatedAndImages: "関連と画像",
		recognitionFileLabel: "認識ファイル",
		recognitionFileHint: "認識に関連するファイルをアップロードします。 例：賞のロゴ、アナリストのレポートなど。",
		addCountrySectorItems: "アイテムを追加",
		removeCountrySectorItems: "アイテムを削除",
		countrySectorItems: "国セクターアイテム",
		countrySectorItemResultHint: "数値を入力してください。 例：20",
		countrySectorItemTextHint: "テキストを入力してください。 例：ドイツ全土の拠点と顧客に近い場所",
		countrySectorItemResult: "結果",
		countrySectorItemText: "テキスト",
		countrySectorItemResultPlaceholder: '例：20',
		countrySectorItemTextPlaceholder: '例：ドイツ全土の拠点と顧客に近い場所',
		countryImage: "国の画像",
		countryImageHint: "国別紹介ページで国別項目の横に表示される国別地図画像をアップロードしてください。",
		recognitionGalleryUploadGroupHint: "認識ギャラリーに画像をアップロードします。 例：賞のロゴ、アナリストのレポートなど。",
		videoLinks: "ビデオリンク",
		videoHintNamePlaceholder: "ビデオのタイトルを入力してください",
		videoHintUrlPlaceholder: "ビデオのURLを入力してください",
		countries: "国",
		infoDate: "情報日",
		marketData: '市場データ'
	},
	[LANGUAGE.es.short]: {
		areYouSure: "¿Estás seguro?",
		confirmAction: "Confirmar acción",
		areYouSureYouWantToUnpublish: "¿Estás seguro de que quieres despublicar?",
		areYouSureYouWantToArchive: "¿Estás seguro de que quieres archivar?",
		areYouSureYouWantToReturnProjectToDraft: "¿Estás seguro de que quieres devolver el proyecto a borrador?",
		areYouSureYouWantToRejectProject: "¿Estás seguro de que quieres rechazar el proyecto?",
		areYouSureYouWantToDeleteProject: "¿Estás seguro de que quieres eliminar el proyecto?",
		areYouSureYouWantToUnarchiveProject: "¿Estás seguro de que quieres desarchivar el proyecto?",
		areYouSureYouWantToArchiveProject: "¿Estás seguro de que quieres archivar el proyecto?",
		theProject: "El proyecto",
		yes: 'Sí',
		no: "No",
		ok: 'OK',
		websiteUnderMaintenance: "Sitio web en mantenimiento",
		weAreImprovingWebsite: "Estamos mejorando el sitio web. Volveremos pronto.",
		startYear: "Año de inicio",
		startMonth: "Mes de inicio",
		endYear: "Año de finalización",
		endMonth: "Mes de finalización",
		year: "Año",
		month: "Mes",
		day: "Día",
		denying: "Negando",
		deny: "Negar",
		cancel: "Cancelar",
		approving: "Aprobando",
		approve: "Aprobar",
		save: "Guardar",
		preview: "Vista previa",
		edit: "Editar",
		loading: "Cargando",
		yourSessionHasExpired: "Tu sesión ha expirado",
		pleaseLoginAgain: "Por favor, inicia sesión de nuevo en:",
		youWillBeLoggedOutIn: "serás desconectado.",
		backToRO: "Volver a RO",
		rejectButton: "Rechazar",
		reasons: "Por favor, escribe las razones de rechazo a continuación.",
		reasonsForRejecting: "Por favor, escribe las razones de rechazo a continuación.",
		writeHere: "Escribe aquí el texto",
		commonPopupPlaceholder: "Escribe aquí el texto",
		commonPopupError: "El campo de texto es obligatorio.",
		name: "Nombre",
		intro: "Introducción",
		offerPresentation: "Presentación de la oferta",
		presentationAndVideoLink: "Presentación y enlace de video",
		globalOwners: "Propietarios",
		akkodisExpertise: "Experiencia de Akkodis",
		marketInsights: "Perspectivas del mercado",
		clientNeedsAndBenefits: "Necesidades y beneficios del cliente",
		tipsAndTricks: "Consejos y trucos",
		referencesAndSuccessStories: "Referencias e historias de éxito",
		actions: 'Acciones',
		validate: 'Validar',
		backToTop: 'Volver arriba',
		submit: 'Enviar',
		presentationType: 'Presentación del sector u oferta',
		presentationTypeSector: 'Sector',
		presentationTypeOffer: 'Oferta',
		title: 'Título',
		presentationTitleHere: 'Título de la presentación aquí',
		thumbnail: 'Miniatura',
		thumbnailHint: "Resolución: más de 300x200px. Relación de aspecto: rectangular 3:2",
		panoramicPhoto: 'Foto panorámica',
		panoramicPhotoHint: "Resolución: 1920x535px o 1200x338px.",
		description: 'Descripción',
		descriptionPlaceholder: 'Proporciona información de fondo sobre la oferta o presentación del sector. El por qué y el contexto, el valor añadido para el cliente.',
		descriptionHint: "Proporciona información de fondo sobre la oferta o presentación del sector. El por qué y el contexto, el valor añadido para el cliente. Aproximadamente 600-800 caracteres, incluidos los espacios.",
		deliveryLocation: 'Ubicación de entrega',
		deliveryLocationPlaceholder: "Selecciona uno o más países",
		singleDeliveryLocationPlaceholder: "Selecciona un país",
		deliveryLocationHint: "Enumera todos los países donde se pueden realizar actividades relacionadas con la oferta",
		length: "Duración",
		ftes: "FTE",
		ftesHint: "Ingresa el número de empleados de Akkodis involucrados en esta actividad",
		presentationPPT: "Versión de presentación PPT",
		presentationPPTHint: "Carga la versión PPT de la presentación (solo en inglés)",
		presentationPDF: "Versión de presentación PDF",
		presentationPDFHint: "Carga la versión PDF de la presentación (solo en inglés)",
		email: "Correo electrónico",
		globalOwnersNameHint: 'Los propietarios solo se mostrarán dentro de GOP. No se mostrarán en documentos externos.',
		globalOwnersEmailHint: 'Los propietarios solo se mostrarán dentro de GOP. No se mostrarán en documentos externos.',
		globalOwnersNamePlaceholder: "Ejemplo: John Silverman",
		globalOwnersEmailPlaceholder: "Ejemplo: john.silverman@mail.com",
		globalOwnersSubTitle: "Propietarios",
		addItem: "Agregar elemento",
		removeItem: "Eliminar elemento",
		addGlobalOwner: "Añadir propietario",
		removeGlobalOwner: "Eliminar propietario",
		videoLink: "Enlace de video",
		videoLinkHint: "Puedes compartir enlaces de video relacionados con la presentación del sector u oferta",
		videoLinkPlaceholder: "URL del video...",
		projectIndustry: "Industria del proyecto",
		projectIndustryHint: "Solo puedes seleccionar una industria para esta oferta o presentación del sector",
		serviceLines: "Tipo de negocio",
		serviceLinesHint: "Puede elegir más de un tipo de negocio para esta oferta o presentación del sector.",
		techPractices: "Prácticas tecnológicas",
		techPracticesHint: "Puedes seleccionar múltiples prácticas tecnológicas para esta oferta o presentación del sector",
		mainClientPersona: "Persona principal del cliente",
		mainClientPersonaHint: "Puedes seleccionar múltiples personas principales del cliente para esta oferta o presentación del sector",
		mainClientPersonaPlaceholder: "Selecciona uno o más dominios",
		lifecycle: "Ciclo de vida",
		lifecycleHint: "Puedes seleccionar múltiples partes del ciclo de vida para esta oferta o presentación del sector",
		lifecyclePlaceholder: "Selecciona una o más partes del ciclo de vida",
		toolsAndSystems: "Herramientas y sistemas",
		toolsAndSystemsHint: "Hardware y software utilizados por el equipo, tecnologías utilizadas. Si agregas una nueva herramienta que no está en las opciones proporcionadas, su fondo se volverá amarillo. Después de la aprobación, el fondo volverá a azul.",
		toolsAndSystemsPlaceholder: "Selecciona una o más herramientas y sistemas",
		certifications: "Certificaciones",
		certificationsHint: "Normas, metodologías, marcos utilizados. Si agregas una nueva certificación que no está en las opciones proporcionadas, su fondo se volverá amarillo. Después de la aprobación, el fondo volverá a azul.",
		certificationsPlaceholder: "Selecciona una o más certificaciones",
		largestMarket: "Mercado más grande",
		largestMarketHint: "Selecciona el país del mercado más grande",
		largestMarketPlaceholder: "Selecciona uno o más países",
		fastestGrowingMarket: "Mercado de más rápido crecimiento",
		fastestGrowingMarketHint: "Selecciona el país del mercado de más rápido crecimiento",
		fastestGrowingMarketPlaceholder: "Selecciona uno o más países",
		biggestMarketConclusion: "Conclusión del mercado más grande",
		biggestMarketConclusionHint: "Puedes proporcionar información de conclusión sobre la sección del mercado más grande. Aproximadamente 150-250 caracteres.",
		biggestMarketConclusionPlaceholder: "Ejemplo: el tamaño del mercado en 2022 fue de 285 millones de dólares",
		keyMarketDrivers: "Principales impulsores del mercado",
		keyMarketDriversHint: "Proporciona información sobre los principales impulsores del mercado. Aproximadamente 400-600 caracteres.",
		keyMarketDriversPlaceholder: "Proporciona información sobre los principales impulsores del mercado.",
		marketOpportunities: "Oportunidades de mercado",
		marketOpportunitiesHint: "Proporciona información sobre las oportunidades de mercado. Aproximadamente 400-600 caracteres.",
		marketOpportunitiesPlaceholder: "Proporciona información sobre las oportunidades de mercado.",
		clientNeeds: "Necesidades del cliente",
		clientNeedsHint: "Proporciona información sobre las necesidades del cliente. Aproximadamente 400-600 caracteres.",
		clientNeedsPlaceholder: "Mensaje sobre las necesidades del cliente.",
		clientBenefits: "Beneficios para el cliente",
		clientBenefitsHint: "Proporciona información sobre los beneficios para el cliente. Aproximadamente 400-600 caracteres.",
		clientBenefitsPlaceholder: "Mensaje sobre los beneficios para el cliente.",
		tips: "Consejos",
		tipsHint: "Proporciona información sobre las necesidades del cliente. Aproximadamente 600-800 caracteres.",
		tipsPlaceholder: "Mensaje sobre los consejos.",
		keyHighlights: "Aspectos destacados clave",
		keyHighlightsHint: "Proporciona información sobre los aspectos destacados clave. Aproximadamente 400-600 caracteres.",
		keyHighlightsPlaceholder: "Proporciona información sobre los aspectos destacados clave.",
		additionalNotes: "Notas adicionales",
		additionalNotesHint: "Si es necesario, agrega notas adicionales para respaldar la presentación de esta oferta o presentación del sector. Aproximadamente 400-600 caracteres.",
		additionalNotesPlaceholder: "Proporciona información sobre los aspectos destacados clave.",
		competitors: "Competidores",
		competitorsHint: "Selecciona los competidores de Akkodis en el mercado. Si agregas un nuevo competidor que no está en las opciones proporcionadas, su fondo se volverá amarillo. Después de la aprobación, el fondo volverá a azul.",
		competitorsPlaceholder: "Selecciona uno o más competidores",
		addReference: "Agregar referencia",
		removeReference: "Eliminar",
		references: "Referencias",
		referenceDescription: "Descripción",
		referenceDescriptionHint: "Proporciona información sobre la referencia utilizada si es necesario.",
		referenceDescriptionPlaceholder: "Ejemplo: HFS Horizons: Generative Enterprise Services, 2023.",
		referenceUrl: "URL",
		referenceUrlHint: "Proporciona la referencia utilizada si es necesario.",
		referenceUrlPlaceholder: "Ejemplo: https://www.hfsresearch.com/Generative-enterprise-2023",
		pleaseWait: "Por favor espera...",
		language: "Selecciona el idioma",
		languageHint: "Al enviar en un idioma diferente, la oferta o presentación del sector se traducirá automáticamente al inglés.",
		languagePlaceholder: "Selecciona el idioma para enviar",
		copyUrlSuccess: "URL copiada con éxito.",
		akkodisAndIndustryPresentation: "Akkodis, presentación de la industria y práctica",
		sectorPresentation: "Presentación del sector",
		generalPresentation: "Presentación general",
		mainTechPractice: "Práctica tecnológica principal",
		mainGlobalOwner: "Propietario principal",
		mainGlobalOwnerPlaceholder: "Seleccionar un propietario principal",
		mainGlobalOwnerHint: "Solo puede elegir un propietario principal",
		mainTechPracticeHint: "Solo se puede seleccionar una práctica tecnológica principal",
		mainTechPracticePlaceholder: "Selecciona una práctica tecnológica",
		mainProjectIndustry: "Industria principal del proyecto",
		mainProjectIndustryHint: "Solo se puede seleccionar una industria principal del proyecto. No se aplica a la presentación de la empresa.",
		mainProjectIndustryPlaceholder: "Selecciona una industria del proyecto",
		mobilePanoramicPhoto: 'Foto panorámica móvil',
		mobilePanoramicPhotoHint: "Resolución: 480x400px o 460x400px",
		doYouWantToProceedWithSubmit: "¿Quieres continuar? Hay campos vacíos.",
		emptyFields: "Campos vacíos",
		referenceStory: "Historia de referencia",
		offerType: "Tipo de oferta",
		offerTypeLabel: "Selecciona el tipo",
		offerTypeHint: "Selecciona el tipo de oferta que deseas enviar",
		offerTypePlaceholder: "Selecciona el tipo de oferta que deseas enviar",
		globalOffer: "Oferta global",
		globalOfferHint: "Selecciona el padre de esta oferta",
		globalOfferPlaceholder: "Selecciona la oferta globalizada",
		deliveryLocationDisabledHint: "No disponible porque ya existe una oferta localizada para este país",
		local: "Local",
		global: "Global",
		localized: "Localizado",
		relatedOffersByContent: "Ofertas relacionadas por contenido",
		relatedSectorsByContent: "Sectores relacionados por contenido",
		relatedPresentationsByContent: "Presentaciones relacionadas por contenido",
		english: "Inglés",
		french: "Francés",
		german: "Alemán",
		italian: "Italiano",
		japanese: "Japonés",
		spanish: "Español",
		noTitle: "Sin título",
		noRelatedOffers: "No hay ofertas relacionadas",
		noRelatedSectors: "No hay presentaciones de sectores relacionadas",
		originalTranslation: "Traducción original",
		for: "para",
		addOffer: "Agregar oferta",
		removeOffer: "Eliminar",
		offerReferences: "Ofertas relacionadas",
		offerLabel: "Oferta",
		offerPlaceholder: "Selecciona una oferta relacionada",
		offerLabelEn: "Oferta en inglés",
		offerHintEn: "Selecciona múltiples ofertas relacionadas en inglés",
		offerPlaceholderEn: "Selecciona múltiples ofertas relacionadas en inglés",
		offerLabelFr: "Oferta en francés",
		offerHintFr: "Selecciona múltiples ofertas relacionadas en francés",
		offerPlaceholderFr: "Selecciona múltiples ofertas relacionadas en francés",
		offerLabelDe: "Oferta en alemán",
		offerHintDe: "Selecciona múltiples ofertas relacionadas en alemán",
		offerPlaceholderDe: "Selecciona múltiples ofertas relacionadas en alemán",
		offerLabelIt: "Oferta en italiano",
		offerHintIt: "Selecciona múltiples ofertas relacionadas en italiano",
		offerPlaceholderIt: "Selecciona múltiples ofertas relacionadas en italiano",
		offerLabelJa: "Oferta en japonés",
		offerHintJa: "Selecciona múltiples ofertas relacionadas en japonés",
		offerPlaceholderJa: "Selecciona múltiples ofertas relacionadas en japonés",
		offerLabelEs: "Oferta en español",
		offerHintEs: "Selecciona múltiples ofertas relacionadas en español",
		offerPlaceholderEs: "Selecciona múltiples ofertas relacionadas en español",
		sectorType: "Tipo de presentación",
		sectorTypeLabel: "Selecciona el tipo",
		sectorTypeHint: "Selecciona el tipo de presentación que deseas enviar",
		sectorTypePlaceholder: "Selecciona el tipo de presentación que desea",
		globalSectors: "Presentación del sector global",
		globalSectorHint: "Selecciona el padre de la presentación del sector localizada",
		globalSectorPlaceholder: "Selecciona el padre localizado",
		sectorReferences: "Presentaciones relacionadas",
		sectorLabelEn: "Presentación en inglés",
		sectorHintEn: "Seleccione una o más presentaciones relacionadas en inglés",
		sectorPlaceholderEn: "Seleccione una o más presentaciones relacionadas en inglés",
		sectorLabelFr: "Presentación en francés",
		sectorHintFr: "Seleccione una o más presentaciones relacionadas en francés",
		sectorPlaceholderFr: "Seleccione una o más presentaciones relacionadas en francés",
		sectorLabelDe: "Presentación en alemán",
		sectorHintDe: "Seleccione una o más presentaciones relacionadas en alemán",
		sectorPlaceholderDe: "Seleccione una o más presentaciones relacionadas en alemán",
		sectorLabelIt: "Presentación en italiano",
		sectorHintIt: "Seleccione una o más presentaciones relacionadas en italiano",
		sectorPlaceholderIt: "Seleccione una o más presentaciones relacionadas en italiano",
		sectorLabelJa: "Presentación en japonés",
		sectorHintJa: "Seleccione una o más presentaciones relacionadas en japonés",
		sectorPlaceholderJa: "Seleccione una o más presentaciones relacionadas en japonés",
		sectorLabelEs: "Presentación en español",
		sectorHintEs: "Seleccione una o más presentaciones relacionadas en español",
		sectorPlaceholderEs: "Seleccione una o más presentaciones relacionadas en español",
		resources: "Recursos",
		resourcesHint: "Puedes seleccionar múltiples recursos para esta oferta o presentación del sector",
		resourcesPlaceholder: "Selecciona uno o más recursos",
		link: "Enlace",
		links: "Enlaces",
		addLink: "Agregar enlace",
		removeLink: "Eliminar",
		linkNameHint: "Nombre del enlace utilizado.",
		linkUrlHint: "Proporciona el enlace utilizado si es necesario.",
		linkName: "Nombre",
		linkUrl: "URL",
		hintNamePlaceholder: "Ejemplo: Noticias relevantes",
		hintUrlPlaceholder: "Ejemplo: https://www.relevantnews.com",
		cannotAddMore: "No se puede agregar más",
		demandGenerationResources: "Recursos de generación de demanda",
		doYouWantToPreloadGlobalOfferData: "¿Quieres precargar los datos de la oferta global?",
		doYouWantToPreloadGlobalSectorData: "¿Quieres precargar los datos del sector global?",
		isCorporatePresentation: "Presentación corporativa",
		recognitions: 'Reconocimientos de Akkodis',
		recognitionsHint: "Puedes agregar reconocimientos relacionados con esta oferta o presentación del sector. Ejemplo: premios, reconocimientos de analistas, etc.",
		recognitionsPlaceholder: "Selecciona uno o más reconocimientos",
		uploadLogo: 'Subir logo',
		uploadResource: 'Subir recurso',
		recognitionDescription: 'Ejemplo: Servicios ER&D y Digital Engineering',
		recognitionLinkHint: 'Puedes agregar un enlace al reconocimiento si no se ha subido un recurso. Si agregas un enlace, elimina el recurso.',
		recognitionsWarning: 'Los reconocimientos incompletos no se guardarán.',
		recognitionsWarningHint: "Los reconocimientos incompletos son aquellos sin descripción, logo, enlace o archivo.",
		addEditor: "Agregar editor",
		removeEditor: "Eliminar",
		editors: "Editores",
		editorsHint: "Otorga permisos de edición, guardado y envío a las personas.",
		editorPlaceholder: "Selecciona uno o más editores",
		editorsSubTitle: "Editores",
		footer: {
			contactUs: 'Contáctanos',
			reportProblem: "Reportar un problema",
			resources: "Recursos",
			contactCMT: 'Contacta a CMT'
		},
		confirmationRequired: 'Confirmación requerida',
		projects: "Proyectos",
		publishedProjects: 'Proyectos publicados',
		revenues: "Ingresos",
		drafts: "Borradores",
		archived: "Archivado",
		shared: "Compartido",
		forReview: "Para revisión",
		surveyQuestions: "Preguntas de la encuesta",
		needHelp: '¿Necesitas ayuda? Haz clic aquí.',
		surveyName: "Nombre de la encuesta",
		questions: "Preguntas",
		deleteQuestion: "Eliminar pregunta",
		addQuestion: "Agregar pregunta",
		type: "Tipo",
		enterQuestionText: "Ingresa el texto de la pregunta",
		answerText: "Texto de respuesta",
		deleteAnswer: "Eliminar respuesta",
		answers: "Respuestas",
		singleChoice: "Opción única",
		multipleChoice: "Opción múltiple",
		textResponse: "Respuesta de texto",
		addAnswer: "Agregar respuesta",
		createSurvey: "Crear encuesta",
		areYouSureYouWantToDeleteSurvey: "¿Estás seguro de que quieres eliminar la encuesta?",
		saveSurvey: "Guardar encuesta",
		surveySaveSuccess: "Encuesta guardada con éxito.",
		surveyGetFailed: "Error al obtener la encuesta. Por favor, inténtalo de nuevo más tarde.",
		surveyNotValid: "La encuesta no es válida. Por favor, verifica las preguntas y respuestas.",
		errorSavingSurvey: "Error al guardar la encuesta. Por favor, inténtalo de nuevo más tarde.",
		delete: "Eliminar",
		active: "Activo",
		setActive: "Establecer como activo",
		activate: "Activar",
		deactivate: "Desactivar",
		createVideo: "Crear video",
		wrongTypePleaseUploadVideo: "Por favor, sube un video. No es del tipo correcto.",
		hide: "Ocultar",
		show: "Mostrar",
		deleteVideoMessage: "¿Estás seguro de que quieres eliminar el video?",
		videoDeletedSuccessfully: "Video eliminado con éxito.",
		successfullySavedVideo: "Video guardado con éxito.",
		wrongId: "ID de video incorrecto.",
		fillAllFields: "Por favor, completa todos los campos.",
		currentVideo: "Video actual",
		videoTitle: "Título del video",
		videoDescription: "Descripción del video",
		confirmVideoTranslations: "Confirmar traducciones de video",
		successfullyCreatedVideo: "Video creado con éxito.",
		errorWhileSaving: "Error al guardar. Por favor, inténtalo de nuevo más tarde.",
		deleteResourceFileMessage: "¿Estás seguro de que quieres eliminar el archivo de recurso?",
		resourceFileDeletedSuccessfully: "Archivo de recurso eliminado con éxito.",
		successfullySavedResourceFile: "Archivo de recurso guardado con éxito.",
		currentResourceFile: "Archivo de recurso actual",
		resourceFileTitle: "Título del archivo de recurso",
		resourceFileDescription: "Descripción del archivo de recurso",
		confirmResourceFileTranslations: "Confirmar traducciones del archivo de recurso",
		successfullyCreatedResourceFile: "Archivo de recurso creado con éxito.",
		createResourceFile: "Crear archivo de recurso",
		wrongTypePleaseUploadResourceFile: "Por favor, sube un archivo de recurso. No es del tipo correcto.",
		downloadCurrentFile: "Descargar archivo actual",
		createPromotion: "Crear promoción",
		deletePromotionMessage: "¿Estás seguro de que quieres eliminar la promoción?",
		promotionDeletedSuccessfully: "Promoción eliminada con éxito.",
		pleaseSelectProject: "Por favor, selecciona un proyecto.",
		promotionCreatedSuccessfully: "Promoción creada con éxito.",
		increase: "Aumentar",
		decrease: "Disminuir",
		promotedUntil: "Promocionado hasta",
		selectAProjectForPromotion: "Selecciona un proyecto para la promoción",
		promote: "Promocionar",
		categoryLabel: "Categoría",
		categoryHint: "Selecciona la categoría a la que deseas enviar",
		categoryPlaceholder: "Selecciona la categoría a la que deseas enviar",
		doYouWantToSendEmailForNextPublishing: "¿Quieres enviar un correo electrónico para la próxima publicación?",
		emailDisabledOnPublish: "El correo electrónico está deshabilitado en la publicación.",
		sendEmail: "Enviar correo electrónico",
		annualRevenue: "Ingresos anuales",
		annualRevenueHint: "Ingresa los ingresos anuales generados por este proyecto",
		annualRevenuePlaceholder: "Ingresa los ingresos anuales",
		maturity: "Madurez",
		maturityHint: "Selecciona el nivel de madurez de este proyecto",
		maturityPlaceholder: "Selecciona el nivel de madurez de este proyecto",
		confirmAndClose: "Confirmar y cerrar",
		startTour: "Iniciar tour",
		welcome: "¡Bienvenido!",
		welcomeText: "Una nueva versión de GOP está disponible. Selecciona tu país para personalizar la experiencia. Puedes iniciar un breve tour para conocer las nuevas funciones o simplemente confirmar y cerrar.",
		country: "País",
		countryPlaceholder: "Selecciona tu país",
		countryError: "Por favor, selecciona un país para continuar.",
		recognition: "Reconocimiento",
		titlePlaceholder: "Ingresa el título aquí",
		file: 'Archivo',
		fileHint: 'Sube un archivo',
		logo: "Logo",
		logoHint: "Sube un logo",
		url: "url",
		urlPlaceholder: "Ingresa la URL aquí",
		region: "Región",
		regionPlaceholder: "Selecciona una región",
		infoDatePlaceHolder: 'Seleccione el año específico relacionado con este reconocimiento',
		badge: "Insignia",
		analysts: "Analistas",
		analystsPlaceholder: "Selecciona los analistas relevantes",
		additionalLinks: "Enlaces adicionales",
		insights: "Perspectivas",
		insightsPlaceholder: "Selecciona las perspectivas relevantes",
		relatedPartnershipPresentations: "Presentaciones de asociación relacionadas",
		relatedPartnershipPresentationsPlaceholder: "Selecciona una o más presentaciones de asociación relacionadas",
		relatedSectors: "Sectores relacionados",
		relatedSectorsPlaceholder: "Selecciona una o más presentaciones de sectores relacionadas",
		relatedSectorsHint: "Selecciona las presentaciones de sectores relacionadas.",
		relatedOffers: "Ofertas relacionadas",
		relatedOffersPlaceholder: "Selecciona una o más ofertas relacionadas",
		relatedOffersHint: "Selecciona una o más ofertas relacionadas.",
		images: "Imágenes",
		logoAndBadge: "Logo e insignia",
		relatedAndImages: "Relacionado e imágenes",
		recognitionFileLabel: "Archivo de reconocimiento",
		recognitionFileHint: "Sube un archivo relacionado con el reconocimiento. Ejemplo: logo del premio, informe del analista, etc.",
		addCountrySectorItems: "Agregar elemento",
		removeCountrySectorItems: "Eliminar elemento",
		countrySectorItems: "Elementos de país y sector",
		countrySectorItemResultHint: "Ingresa un número. Ejemplo: 20",
		countrySectorItemTextHint: "Ingresa un texto. Ejemplo: Ubicaciones en toda Alemania cerca de las bases y clientes",
		countrySectorItemResult: "Resultado",
		countrySectorItemText: "Texto",
		countrySectorItemResultPlaceholder: 'Ejemplo: 20',
		countrySectorItemTextPlaceholder: 'Ejemplo: Ubicaciones en toda Alemania cerca de las bases y clientes',
		countryImage: "Imagen del país",
		countryImageHint: "Sube una imagen de mapa del país que se mostrará junto a los elementos de país y sector en la página de descripción general del país.",
		recognitionGalleryUploadGroupHint: "Sube imágenes a la galería de reconocimientos. Ejemplo: logo del premio, informe del analista, etc.",
		videoLinks: "Enlaces de video",
		videoHintNamePlaceholder: "Ingresa el título del video",
		videoHintUrlPlaceholder: "Ingresa la URL del video",
		countries: "Países",
		infoDate: "Fecha de información",
		marketData: 'Datos de mercado'
	},
}
